/* eslint-disable no-undef */
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Link, useNavigate } from "react-router-dom";
import styles from "./EditProfile.module.css";
import DatePickerSample from "../../../DatePicker";
import { ImageUrlPrefix } from "../../../../../labels";
import Select from "react-select";
import { customStyles } from "../../../../../pages/customStyles";
import MonthDatePicker from "../../../MonthDatePicker";
import moment from "moment";
import { AxiosInstance } from "../../../../../axios";
import { UserContext } from "../../../../../context/UserDetails";
import { Download } from "@mui/icons-material";
import intlTelInput from "intl-tel-input";
import { EventType } from "@azure/msal-browser";

const optionSEducation = [
  { value: "State Board", label: "State Board" },
  { value: "Matriculation", label: "Matriculation" },
  { value: "CBSE", label: "CBSE" },
  { value: "ICSE", label: "ICSE" },
  { value: "Others", label: "Others" },
];
const optionsMedium = [
  { value: "Tamil Medium", label: "Tamil Medium" },
  { value: "English Medium", label: "English Medium" },
];
const optionClass = [
  { value: "DISTINCTION", label: "DISTINCTION" },
  { value: "FIRST CLASS", label: "FIRST CLASS" },
  {
    value: "FIRST CLASS WITH DISTINCTION",
    label: "FIRST CLASS WITH DISTINCTION",
  },
  { value: "SECOND CLASS", label: "SECOND CLASS" },
  { value: "THIRD CLASS", label: "THIRD CLASS" },
];

//  You can define     components for each step's form here:
const PersonalProfileForm = forwardRef(
  ({ list, setList, listErrors, setListErrors }, ref) => {
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const fatherNameRef = useRef(null);
    const motherNameRef = useRef(null);
    const dobRef = useRef(null);
    const genderRef = useRef(null);
    const maritalStatusRef = useRef(null);
    const profilePhotoRef = useRef(null);
    const aadharNoRef = useRef(null);
    const aadharCardRef = useRef(null);
    const communityRef = useRef(null);
    const castRef = useRef(null);
    useImperativeHandle(ref, () => ({
      refs: {
        firstNameRef,
        lastNameRef,
        fatherNameRef,
        motherNameRef,
        dobRef,
        genderRef,
        maritalStatusRef,
        profilePhotoRef,
        aadharNoRef,
        aadharCardRef,
        communityRef,
        castRef,
      },
    }));

    const { logout } = useContext(UserContext);
    const stateRefresh = sessionStorage.getItem("stateRefreshs");
    const [categoryOption, setCategoryOption] = useState([]);
    const [step, setStep] = useState(1);
    const txtAdMDob = useRef(null);
    const [dropdown, setDropDown] = useState({ community_name: null });

    const userJSON = sessionStorage.getItem("userDetails");
    let userid = null;

    if (userJSON) {
      const user = JSON.parse(userJSON);
      userid = user?.user_id || null;
      if (!userid) logout();
    }

    const fetchUserInfo = async (userId) => {
      try {
        const res = await AxiosInstance.post(
          `api/course/admission/info_view/${userId}/0`
        );
        const userinfo = res.data.data;

        setList((prev) => ({
          ...prev,
          FirstName: userinfo.first_name || "",
          LastName: userinfo.last_name || "",
          Fathername: userinfo.father_name || "",
          MotherName: userinfo.mother_name || "",
          Profilephoto:
            userinfo.profile_path !== null ? userinfo.profile_path : null,
          original_profile_path: userinfo.original_profile_path || null,
          original_aadhar_path: userinfo.original_aadhar_path || null,
          original_caste_path: userinfo.original_caste_path || null,
          DOB: userinfo.dob || "",
          age: userinfo.age || 0,
          gender: userinfo.gender || "Male",
          MaritalStatus: userinfo.marital_status || "Single/Unmarried",
          aadharNo: userinfo.aadhar_no || "",
          aadharCardphoto: userinfo.aadhar_path || null,
        }));

        if (userinfo.community) {
          setDropDown((prev) => ({
            ...prev,
            community_name: {
              value: userinfo.community,
              label: userinfo.community,
            },
          }));

          setList((prev) => ({
            ...prev,
            community_name: userinfo.community,
          }));
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };
    const handleSelectMulti = (option, fieldName) => {
      setList((prev) => ({
        ...prev,
        [fieldName]: option?.value || "",
      }));

      // Clear the error if value is selected
      if (option?.value) {
        setListErrors((prev) => ({
          ...prev,
          [fieldName]: "",
        }));
      }
    };
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [step]);

    useEffect(() => {
      if (userid && stateRefresh !== null) {
        fetchUserInfo(userid);
      }
    }, [stateRefresh, userid]);

    useEffect(() => {
      AxiosInstance.get("api/codevalues?codetype=CTGY")
        .then((res) => {
          const categoryOption = res.data.map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
          // Sort the options alphabetically, ignoring "Nil"
          const sortedOptions = categoryOption
            .filter((item) => item.value !== "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          const NilOption = categoryOption
            .filter((item) => item.value === "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          // Set the sorted list to the state
          sortedOptions.push(...NilOption);
          setCategoryOption(sortedOptions);
        })
        .catch((error) => {
          return error;
        });
    }, []);

    const handleChange = (e) => {
      const { name, type, files, value } = e.target;
      // Basic text, radio, number inputs
      setList((prev) => ({
        ...prev,
        [name]: type === "number" ? Number(value) : value,
      }));

      let errorMsg = "";
      // Regex for letters and spaces only
      const onlyLettersRegex = /^[A-Za-z\s]*$/;
      switch (name) {
        case "FirstName":
          if (value.trim() === "") {
            errorMsg = "Please enter the first name";
          } else if (!onlyLettersRegex.test(value)) {
            errorMsg = "Only letters are allowed";
          }
          break;

        case "LastName":
          if (value.trim() === "") {
            errorMsg = "Please enter the last name";
          } else if (!onlyLettersRegex.test(value)) {
            errorMsg = "Only letters are allowed";
          }
          break;

        case "Fathername":
          if (value.trim() === "") {
            errorMsg = "Please enter the father's name";
          } else if (!onlyLettersRegex.test(value)) {
            errorMsg = "Only letters are allowed";
          }
          break;

        case "MotherName":
          if (value.trim() === "") {
            errorMsg = "Please enter the mother's name";
          } else if (!onlyLettersRegex.test(value)) {
            errorMsg = "Only letters are allowed";
          }
          break;
        case "gender":
          errorMsg = value.trim() === "" ? "Please select your gender" : "";
          break;
        case "MaritalStatus":
          errorMsg =
            value.trim() === "" ? "Please select your marital status" : "";
          break;
        case "aadharNo":
          if (value.length === 12 || value.length === 0) {
            setList((prevList) => ({
              ...prevList,
              [name]: value,
            }));
            setListErrors({
              ...listErrors,
              ["aadharNo"]: "",
            });
          } else {
            setList((prevList) => ({
              ...prevList,
              [name]: value,
            }));
            setListErrors({
              ...listErrors,
              ["aadharNo"]: "Please Enter valid 12 digit number",
            });
            return;
          }
          // if (value.length === 12 || value.length <= 0) {
          //   errorMsg = "Please enter Aadhar number";
          // } else if (!/^\d{12}$/.test(value)) {
          //   errorMsg = "Please enter valid 12 digit number";
          // }
          break;
        default:
          errorMsg = "";
      }

      setListErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));

      if (name === "Profilephoto" && files && files.length > 0) {
        const profile_path = files[0];

        setList((prev) => ({
          ...prev,
          profileFile: profile_path, // save raw file for later size check
        }));

        if (
          files[0].type === "image/png" ||
          files[0].type === "image/jpg" ||
          files[0].type === "image/jpeg"
        ) {
          if (files[0].size < 40 * 1024) {
            const formData = new FormData();
            formData.append("profile_path", profile_path);

            AxiosInstance.post("api/upload/", formData)
              .then((res) => {
                setList((prev) => ({
                  ...prev,
                  Profilephoto: res.data.path,
                  original_profile_path: res.data.originalname,
                }));
                setListErrors((prev) => ({
                  ...prev,
                  Profilephoto: "",
                }));
              })
              .catch((error) => {
                return error;
              });
          } else {
            setListErrors((prev) => ({
              ...prev,
              Profilephoto: "File size must be less than 40KB",
            }));
          }
        } else {
          setListErrors((prev) => ({
            ...prev,
            Profilephoto: "(Png, jpg, jpeg) images only allowed",
          }));
        }
      } else if (name === "aadharCardphoto" && files && files.length > 0) {
        const file = files[0];

        const validTypes = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "application/pdf",
        ];

        if (validTypes.includes(file.type)) {
          if (file.size < 2 * 1024 * 1024) {
            const formData = new FormData();
            formData.append("aadhar_path", file);

            AxiosInstance.post("api/upload/", formData)
              .then((res) => {
                setList({
                  ...list,
                  aadharCardphoto: res.data.path,
                  original_aadhar_path: res.data.originalname,
                  aadharCardFile: file, //  this is important for handleNext to validate
                });

                setListErrors({
                  ...listErrors,
                  aadharCardphoto: "",
                });
              })
              .catch((error) => {
                return error;
              });
          } else {
            setListErrors({
              ...listErrors,
              aadharCardphoto: "File size must be less than 2MB",
            });

            setList((prev) => ({
              ...prev,
              aadharCardphoto: "",
              original_aadhar_path: "",
              aadharCardFile: null,
            }));
          }
        } else {
          setListErrors({
            ...listErrors,
            aadharCardphoto: "Only PDF, PNG, JPG, and JPEG files are allowed.",
          });

          setList((prev) => ({
            ...prev,
            aadharCardphoto: "",
            original_aadhar_path: "",
            aadharCardFile: null,
          }));
        }
      } else if (name === "CastFile" && files && files.length > 0) {
        const file = files[0];

        // Save the raw file for validation
        setList((prev) => ({ ...prev, castFileObj: file }));

        if (
          file.type === "application/pdf" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        ) {
          if (file.size <= 2 * 1024 * 1024) {
            const formData = new FormData();
            formData.append("community_path", file);
            AxiosInstance.post("api/upload/", formData)
              .then((res) => {
                setList((prev) => ({
                  ...prev,
                  CastFile: res.data.path,
                  original_caste_path: res.data.originalname,
                }));
                setListErrors((prev) => ({ ...prev, CastFile: "" }));
              })
              .catch((error) => {
                console.error("Upload error:", error);
              });
          } else {
            setListErrors((prev) => ({
              ...prev,
              CastFile: "File must be less than 2MB",
            }));
          }
        } else {
          setListErrors((prev) => ({
            ...prev,
            CastFile: "PDF, PNG, JPG, and JPEG files only allowed",
          }));
        }
      }
    };
    useEffect(() => {
      return () => {
        if (list.preview_Profilephoto_url) {
          URL.revokeObjectURL(list.preview_Profilephoto_url);
        }
      };
    }, [list.preview_Profilephoto_url]);
    const DobCovertAge = (dob) => {
      var ageInYears = moment().diff(dob, "years", false);
      return ageInYears;
    };
    const handleChangeDate = (date, name) => {
      const dateDOB = moment(date).format("YYYY-MM-DD");
      const age = DobCovertAge(date);
      if (age >= 18 && age <= 60) {
        setList({
          ...list,
          [name]: dateDOB,
          ["age"]: age,
        });
        setListErrors({
          ...listErrors,
          [name]: "",
          ["age"]: "",
        });
      } else {
        const err =
          "Please enter a valid date of birth age should be between 18 and 60 years";
        setList({
          ...list,
          age: "",
        });
        setListErrors({
          ...listErrors,
          DOB: err,
        });
      }
    };
    const handleYearChange = (year, dname) => {
      if (dname === "DOB") {
        if (list.DOB !== null && list.DOB !== "") {
          const currentDate = new Date(list.DOB);
          const newYear = year;
          currentDate.setFullYear(newYear);
          const currentDate_moment = moment(currentDate).format("yyyy-mm-");
          const age = DobCovertAge(currentDate_moment);
          if (age >= 18 && age <= 60) {
            setList({
              ...list,
              ["DOB"]: currentDate_moment,
              ["age"]: age,
            });
            setListErrors({
              ...listErrors,
              ["DOB"]: "",
              ["age"]: "",
            });
          } else {
            const err =
              "Please enter a valid date of birth. age should be between 18 and 60 years";
            setList({
              ...list,
              age: "",
            });
            setListErrors({
              ...listErrors,
              DOB: err,
            });
          }
        }
      } else if (dname === "JoinGovt") {
        if (
          list.JoinGovt !== null &&
          list.JoinGovt !== "" &&
          list.JoinGovt !== undefined
        ) {
          const currentDate = new Date(list.JoinGovt);
          const newYear = year;
          currentDate.setFullYear(newYear);
          const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
          setList({
            ...list,
            ["JoinGovt"]: currentDate_moment,
          });
        } else {
          const currentDate = new Date();
          const newYear = year;
          currentDate.setFullYear(newYear);
          const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
          setList({
            ...list,
            ["JoinGovt"]: currentDate_moment,
          });
        }
      }
    };

    const handleMonthChange = (month, dname) => {
      if (dname === "DOB") {
        if (list.DOB !== null && list.DOB !== "") {
          const currentDate = new Date(list.DOB);
          let monthNumber = moment(month, "MMMM").month();
          currentDate.setMonth(monthNumber);
          const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
          const age = DobCovertAge(currentDate_moment);
          if (age >= 18 && age <= 60) {
            setList({
              ...list,
              ["DOB"]: currentDate_moment,
              ["age"]: age,
            });
            setListErrors({
              ...listErrors,
              ["DOB"]: "",
              ["age"]: "",
            });
          } else {
            const err =
              "Please enter a valid date of birth. age should be between 18 and 60 years";
            setList({
              ...list,
              age: "",
            });
            setListErrors({
              ...listErrors,
              DOB: err,
            });
          }
        }
      }
    };

    return (
      <div className="PersonalProfileForm">
        <fieldset className="mt-3">
          <legend className="w-auto">Basic Details</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label htmlFor="FirstName" className="form-label confirm_value">
                First Name
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={firstNameRef}
                type="text"
                id="FirstName"
                name="FirstName"
                placeholder="Enter the first name"
                value={list.FirstName}
                onChange={handleChange}
              />
              {listErrors.FirstName && (
                <small className="error_message">{listErrors.FirstName}</small>
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="LastName" className="form-label confirm_value">
                Last Name
              </label>
              <input
                ref={lastNameRef}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="LastName"
                name="LastName"
                placeholder="Enter the last name"
                value={list.LastName}
                onChange={handleChange}
              />
              {listErrors.LastName && (
                <small className="error_message">{listErrors.LastName}</small>
              )}
            </div>

            <div class="col-md-6">
              <label for="Fathername" class="form-label confirm_value ">
                Father's Name/Guardian's Name
              </label>
              <input
                ref={fatherNameRef}
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="Fathername"
                name="Fathername"
                placeholder="Enter the father's name/guardian's name"
                value={list.Fathername}
                onChange={handleChange}

                //   onChange={(e) => setList({ ...list, Fathername: e.target.value })}
              />
              {listErrors.Fathername && (
                <small className="error_message">{listErrors.Fathername}</small>
              )}
            </div>
            <div class="col-md-6">
              <label for="MotherName" class="form-label confirm_value ">
                Mother's Name
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                ref={motherNameRef}
                id="MotherName"
                name="MotherName"
                placeholder="Enter the mother's name"
                value={list.MotherName}
                onChange={handleChange}
                //   onChange={(e) => setList({ ...list, MotherName: e.target.value })}
              />
              {listErrors.MotherName && (
                <small className="error_message">{listErrors.MotherName}</small>
              )}
            </div>
            <div className="col-md-6">
              <label htmlFor="DOB" className="form-label confirm_value">
                Date of Birth
              </label>
              <DatePickerSample
                handleYearChange={handleYearChange}
                handleMonthChange={handleMonthChange}
                disabledProperty={list.admission_status === 1 ? true : false}
                txtAdMDob={txtAdMDob}
                name={"DOB"}
                handleChange={handleChangeDate}
                fieldInput={
                  list.DOB ? moment(list.DOB).format("YYYY-MM-DD") : ""
                }
              />
              {listErrors.DOB && (
                <small className="error_message">{listErrors.DOB}</small>
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="age" className="form-label confirm_value">
                Age
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="number"
                ref={dobRef}
                id="age"
                name="age"
                value={list.age} // Automatically updates when DOB changes
                placeholder="Age"
                autoComplete="age"
                disabled
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="Gender" className="form-label confirm_value">
                Gender
              </label>
              <div>
                {["Male", "Female", "Transgender"].map((option) => (
                  <React.Fragment key={option}>
                    <input
                      className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                      type="radio"
                      id={option}
                      ref={genderRef}
                      name="gender"
                      value={option}
                      checked={list.gender === option}
                      onChange={handleChange}
                    />
                    <label
                      className="form-label confirm_value me-3"
                      htmlFor={option}
                    >
                      {option}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <label
                htmlFor="MaritalStatus"
                className="form-label confirm_value"
              >
                Marital Status
              </label>
              <div>
                {["Single/Unmarried", "Married", "Widowed"].map((option) => (
                  <React.Fragment key={option}>
                    <input
                      className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                      type="radio"
                      id={option}
                      ref={maritalStatusRef}
                      name="MaritalStatus"
                      value={option}
                      checked={list.MaritalStatus === option}
                      onChange={handleChange}
                    />
                    <label
                      className="form-label confirm_value me-3"
                      htmlFor={option}
                    >
                      {option}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </form>
        </fieldset>
        {/* passport photograph */}
        <fieldset className="mt-3">
          <legend className="w-auto">Passport Size Photograph</legend>
          <form className="row g-3">
            {/* Displaying uploaded profile image */}
            <div className="col-md-6 d-flex justify-content-center">
              <div className="position-relative text-center">
                {list.Profilephoto ? (
                  <img
                    className={`${styles.ProfilePhoto} bg-opacity-75`}
                    src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                    alt="Profile"
                  />
                ) : (
                  <div
                    className={`${styles.ProfilePhoto} d-flex align-items-center justify-content-center bg-opacity-75`}
                  >
                    <span id="text">Profile Picture</span>
                  </div>
                )}
              </div>
            </div>

            {/* Upload section */}
            <div className="col-md-6">
              <label
                htmlFor="Profilephoto"
                className="form-label confirm_value"
              >
                Upload Passport Size Photograph
              </label>
              <div className="row d-flex align-items-center">
                <div>
                  <input
                    className="InputsSelectFile m-0"
                    id="Profilephoto"
                    type="file"
                    ref={profilePhotoRef}
                    name="Profilephoto"
                    onChange={handleChange}
                    autoComplete="Profilephoto"
                    accept="image/jpeg,image/png"
                    required
                  />
                </div>
                {list.Profilephoto !== "" && list.Profilephoto !== null && (
                  <div className="mt-1">
                    <span className={`${styles.uploadFile} m-0`}>
                      {list.Profilephoto !== "" && list.Profilephoto !== null
                        ? list.original_profile_path
                        : ""}
                    </span>
                  </div>
                )}
                {/* Error display */}
                {listErrors.Profilephoto && (
                  <small className="error_message">
                    {listErrors.Profilephoto}
                  </small>
                )}
              </div>

              {/* Note section */}
              <div className="Note mt-3">
                <h6 className={styles.profileNote}>Note</h6>
                <p className={styles.noteOne}>
                  <span className={styles.note_subheader}>Image format: </span>
                  The recommended image format for profile pictures on Anna IAS
                  Academy is JPEG or PNG.
                </p>
                <p className={styles.noteOne}>
                  <span className={styles.note_subheader}>Image size: </span>
                  Profile pictures should be a minimum of 400x400 pixels and a
                  maximum of 1024x1024 pixels. The file size should not exceed
                  40 KB.
                </p>
                <p className={styles.noteOne}>
                  <span className={styles.note_subheader}>
                    Image quality and content:{" "}
                  </span>
                  Choose a clear and high-quality image for your profile
                  picture. Your profile picture should be appropriate and
                  professional.
                </p>
                <p className={styles.noteOne}>
                  <span className={styles.note_subheader}>
                    Image orientation:{" "}
                  </span>
                  Profile pictures should be in a square format, as they will be
                  displayed as a circle on the platform. Make sure your image is
                  not stretched or distorted.
                </p>
              </div>
            </div>
          </form>
        </fieldset>

        {/* ID Proofs */}
        <fieldset className="mt-3">
          <legend className="w-auto">ID Proofs</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label for="aadharNo" class="form-label confirm_value">
                AADHAR Number
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="number"
                ref={aadharNoRef}
                id="aadharNo"
                name="aadharNo"
                placeholder="Enter the aadhar number"
                required
                minLength={12}
                autoComplete="aadharNo"
                value={list.aadharNo < 0 ? 0 : list.aadharNo}
                // onChange={(e) => setList({ ...list, aadharNo: e.target.value })}
                onChange={handleChange}
              />
              {listErrors.aadharNo && (
                <small className="error_message">{listErrors.aadharNo}</small>
              )}
            </div>
            <div className="col-md-6">
              <label
                htmlFor="aadharCardphoto"
                className="form-label confirm_value"
              >
                Upload AADHAR Card (In pdf/Image format)
                {list.aadharCardphoto !== "" &&
                  list.aadharCardphoto !== null && (
                    <a
                      href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                      target="_blank"
                      download
                    >
                      <span className="material-icons download_icon align-middle text-danger ">
                        file_download
                      </span>
                    </a>
                  )}
              </label>
              <div className="row d-flex align-items-center">
                <div>
                  <input
                    //   ref={txtAdApath}
                    className="InputsSelectFile m-0"
                    ref={aadharCardRef}
                    id="aadharCardphoto"
                    type="file"
                    name="aadharCardphoto"
                    placeholder="Upload AADHAR Card"
                    onChange={handleChange}
                    autoComplete="aadharCardphoto"
                    required
                  />
                </div>
                {list.aadharCardphoto !== "" &&
                  list.aadharCardphoto !== null && (
                    <div className="mt-1">
                      <span className={`${styles.uploadFile} m-0`}>
                        {list.aadharCardphoto !== "" &&
                        list.aadharCardphoto !== null
                          ? list.original_aadhar_path
                          : ""}
                      </span>
                    </div>
                  )}
              </div>
              {listErrors.aadharCardphoto && (
                <small className="error_message">
                  {listErrors.aadharCardphoto}
                </small>
              )}
            </div>
          </form>
        </fieldset>
        {/* communal reservation category */}
        <fieldset className="mt-3">
          <legend className="w-auto">Communal Reservation Category</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label for="community_name" class="form-label confirm_value ">
                Category
              </label>
              <Select
                id="community_name"
                ref={communityRef}
                className={styles.categoryName}
                placeholder="Select an option"
                isDisabled={list.admission_status === 1}
                value={
                  categoryOption.find(
                    (opt) => opt.value === list.community_name
                  ) || null
                }
                onChange={(option) =>
                  handleSelectMulti(option, "community_name")
                }
                options={categoryOption}
                isSearchable={true}
                maxMenuHeight={200}
                styles={customStyles}
              />
              {listErrors.community_name && (
                <small className="error_message">
                  {listErrors.community_name}
                </small>
              )}
            </div>
            <div className="col-md-6">
              <label htmlFor="CastFile" className="form-label confirm_value">
                Upload Community Certificate (In PDF/Image format)
                <span className="form-label confirm_label"> (Optional)</span>
                {list.CastFile !== "" && list.CastFile !== null && (
                  <a
                    href={`${ImageUrlPrefix}/${list.CastFile}`}
                    target="_blank"
                    download
                  >
                    <span className="material-icons download_icon align-middle text-danger">
                      file_download
                    </span>
                  </a>
                )}
              </label>

              <div className="row d-flex align-items-center">
                <div>
                  <input
                    className="InputsSelectFile m-0"
                    ref={castRef}
                    id="CastFile"
                    type="file"
                    name="CastFile"
                    onChange={handleChange}
                    autoComplete="CastFile"
                  />
                </div>
                {list.CastFile !== "" && list.CastFile !== null && (
                  <div className="mt-1">
                    <span className={`${styles.uploadFile} m-0`}>
                      {list.CastFile !== "" && list.CastFile !== null
                        ? list.original_caste_path
                        : ""}
                    </span>
                  </div>
                )}
              </div>

              {listErrors.CastFile && (
                <span className="error_message">{listErrors.CastFile}</span>
              )}
            </div>
          </form>
        </fieldset>
      </div>
    );
  }
);
const CommunicationForm = forwardRef(
  ({ userId, addressList, setAddressList, listErrors, setListErrors }, ref) => {
    const txtAdPno = useRef(null);
    const txtAdWno = useRef(null);
    const txtAdFpo = useRef(null);
    const [apiData, setApiData] = useState(null);
    const [isSameAsPhone, setIsSameAsPhone] = useState(false);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      if (/^\d{0,10}$/.test(value)) {
        setAddressList((prev) => ({ ...prev, [name]: value }));
        setListErrors((prev) => ({ ...prev, [name]: "" }));
      }
    };

    const handleBlur = (e) => {
      const { name, value } = e.target;
      if (
        (name === "phone_no" ||
          name === "whatsapp_no" ||
          name === "parent_mob_no") &&
        !/^\d{10}$/.test(value)
      ) {
        setListErrors((prev) => ({
          ...prev,
          [name]: "Please enter a valid 10 digit number",
        }));
      }
    };

    const validateFields = () => {
      const errors = {};
      let focusField = null;

      if (!/^\d{10}$/.test(addressList.phone_no || "")) {
        errors.phone_no = "Please enter a valid 10 digit number";
        focusField = txtAdPno;
      }
      setListErrors(errors);
      if (focusField) focusField.current?.focus();

      return Object.keys(errors).length === 0;
    };
    useImperativeHandle(ref, () => ({
      validateFields,
    }));
    const fetchUserInfo = async (userId) => {
      try {
        const res = await AxiosInstance.post(
          `api/course/admission/info_view/${userId}/0`
        );
        const userinfo = res.data.data;
        // Ensure addresses are properly structured
        const addresses = userinfo.address || [];
        setIsSameAsPhone(userinfo?.contact_type === 1 ? true : false);
        setAddressList({
          phone_no: userinfo.phone_no || null,
          email: userinfo.email || null,
          whatsapp_no: userinfo.whatsapp_no || null,
          parent_mob_no: userinfo.parent_mob_no || null,
          contact_type: userinfo.contact_type || 0,
          country_code: userinfo.country_code || "",
          address: [
            {
              address1: addresses[0]?.address1 || "",
              address2: addresses[0]?.address2 || "",
              address3: addresses[0]?.address3 || "",
              landmark: addresses[0]?.landmark || "",
              post_name: addresses[0]?.post_name || "",
              taluk: addresses[0]?.taluk || "",
              postal_code: addresses[0]?.postal_code || "0", // Default to "0"
              city: addresses[0]?.city || "",
              district_name: addresses[0]?.district_name || "",
              state_name: addresses[0]?.state_name || "",
              same_address: addresses[0]?.same_address ?? "1",
              address_type: "1",
            },
            {
              address1: addresses[1]?.address1 || "",
              address2: addresses[1]?.address2 || "",
              address3: addresses[1]?.address3 || "",
              landmark: addresses[1]?.landmark || "",
              post_name: addresses[1]?.post_name || "",
              taluk: addresses[1]?.taluk || "",
              postal_code: addresses[1]?.postal_code || "0", // Default to "0"
              city: addresses[1]?.city || "",
              district_name: addresses[1]?.district_name || "",
              state_name: addresses[1]?.state_name || "",
              same_address: addresses[1]?.same_address ?? "1",
              address_type: "2",
            },
          ],
        });
        addresses?.forEach((item, index) => {
          const postalCode = String(item.postal_code);
          if (postalCode.length === 6) {
            GetCityByPincode(postalCode, index);
          }
        });
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    //  Handle changes for address fields inside the array
    const handleAddressChange = (e, index) => {
      const { name, value } = e.target;
      setAddressList((prevState) => {
        const updatedAddress = [...prevState.address];
        // Always update the targeted address
        updatedAddress[index] = {
          ...updatedAddress[index],
          [name]: value,
        };
        const isSame = String(updatedAddress[1]?.same_address) === "0";
        // If "Same as Present" is checked (same_address === "0") and user edits Present
        if (isSame && index === 0) {
          updatedAddress[1] = {
            ...updatedAddress[1],
            [name]: value,
          };
        }
        return {
          ...prevState,
          address: updatedAddress,
        };
      });
    };

    useEffect(() => {
      if (apiData) {
        const present = { ...apiData.presentAddress, address_type: "1" };
        const isSame = apiData.same_address === "1";

        const permanent = isSame
          ? { ...present, address_type: "2", same_address: "1" }
          : {
              ...apiData.permanentAddress,
              address_type: "2",
              same_address: "0",
            };

        setAddressList({ address: [present, permanent] });
      }
    }, [apiData]);

    const handleSameAddressToggle = (e) => {
      const isChecked = e.target.checked;
      const newSameAddress = isChecked ? "0" : "1";

      setAddressList((prevState) => {
        const presentAddress = prevState.address[0];

        const updatedPermanent = isChecked
          ? {
              ...presentAddress,
              address_type: "2",
              same_address: "1",
            }
          : {
              address1: "",
              address2: "",
              address3: "",
              landmark: "",
              post_name: "",
              taluk: "",
              postal_code: "0",
              city: "",
              district_name: "",
              state_name: "",
              cityOptions: [],
              isDropdown: false,
              address_type: "2",
              same_address: "1",
            };

        return {
          ...prevState,
          address: [
            {
              ...presentAddress,
              same_address: newSameAddress,
            },
            {
              ...updatedPermanent,
              same_address: newSameAddress, // Ensure both have the same value
            },
          ],
        };
      });
    };

    const handlePincodeChange = (e, index) => {
      let input = e.target.value.replace(/\D/g, ""); // Keep only digits

      if (input.length > 6) input = input.slice(0, 6);

      setAddressList((prevState) => {
        const updatedAddress = [...prevState.address];

        const sameAddress1 = String(updatedAddress[0]?.same_address) === "0";
        const sameAddress2 = String(updatedAddress[1]?.same_address) === "0";

        const clearFields = {
          postal_code: input,
          city: "",
          cityOptions: [],
          district_name: "",
          state_name: "",
          isDropdown: false,
        };

        // Case 1: Both are editable
        if (sameAddress1 && sameAddress2) {
          updatedAddress[0] = { ...updatedAddress[0], ...clearFields };
          updatedAddress[1] = { ...updatedAddress[1], ...clearFields };
        }
        // Case 2: Present address updated and permanent is same
        else if (
          index === 0 &&
          String(updatedAddress[1]?.same_address) === "1"
        ) {
          updatedAddress[0] = { ...updatedAddress[0], ...clearFields };
          updatedAddress[1] = { ...updatedAddress[1], ...clearFields };
        }
        // Case 3: Default single update
        else {
          updatedAddress[index] = { ...updatedAddress[index], ...clearFields };
        }

        return {
          ...prevState,
          address: updatedAddress,
        };
      });

      if (input.length === 6) {
        GetCityByPincode(input, index);
      }
    };

    const GetCityByPincode = async (cleanedPincode, index) => {
      try {
        const response = await AxiosInstance.get(
          `api/all/getAddress/${cleanedPincode}`
        );

        if (response.data && response.data.data.length > 0) {
          const cityOptions = response.data.data.map((item) => ({
            value: item.city,
            label: item.city,
            district: item.district,
            state: item.state,
          }));

          setAddressList((prevState) => {
            const sameAddress1 =
              String(prevState.address[0]?.same_address) === "0";
            const sameAddress2 =
              String(prevState.address[1]?.same_address) === "0";

            return {
              ...prevState,
              address: prevState.address.map((addr, i) =>
                (sameAddress1 && sameAddress2) || i === index
                  ? {
                      ...addr,
                      cityOptions,
                      district_name: response.data.data[0].district,
                      state_name: response.data.data[0].state,
                      isDropdown: true,
                    }
                  : addr
              ),
            };
          });
        } else {
          // No valid address found
          setAddressList((prevState) => {
            const sameAddress1 =
              String(prevState.address[0]?.same_address) === "0";
            const sameAddress2 =
              String(prevState.address[1]?.same_address) === "0";

            return {
              ...prevState,
              address: prevState.address.map((addr, i) =>
                (sameAddress1 && sameAddress2) || i === index
                  ? {
                      ...addr,
                      cityOptions: [],
                      isDropdown: true,
                    }
                  : addr
              ),
            };
          });
        }
      } catch (error) {
        console.error("Error fetching address data:", error);
      }
    };

    const handleCityChange = (selectedOption, index) => {
      setAddressList((prevState) => {
        const updatedAddress = [...prevState.address];

        const sameAddress1 = String(updatedAddress[0]?.same_address) === "0";
        const sameAddress2 = String(updatedAddress[1]?.same_address) === "0";

        const cityFields = {
          city: selectedOption.value,
          district_name: selectedOption.district,
          state_name: selectedOption.state,
          isDropdown: true,
        };

        // Case 1: Both editable
        if (sameAddress1 && sameAddress2) {
          updatedAddress[0] = { ...updatedAddress[0], ...cityFields };
          updatedAddress[1] = { ...updatedAddress[1], ...cityFields };
        }
        // Case 2: Present updated, permanent is same
        else if (
          index === 0 &&
          String(updatedAddress[1]?.same_address) === "1"
        ) {
          updatedAddress[0] = { ...updatedAddress[0], ...cityFields };
          updatedAddress[1] = { ...updatedAddress[1], ...cityFields };
        }
        // Case 3: Single update
        else {
          updatedAddress[index] = { ...updatedAddress[index], ...cityFields };
        }

        return {
          ...prevState,
          address: updatedAddress,
        };
      });
    };

    useEffect(() => {
      setAddressList((prev) => ({
        ...prev,
        whatsapp_no: isSameAsPhone ? prev.phone_no : null,
      }));
    }, [isSameAsPhone, addressList.phone_no]);

    useEffect(() => {
      // Initialize intl-tel-input on component mount
      const iti = intlTelInput(txtAdPno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdPno.current.addEventListener("countrychange", () => {
        const selectedCountryData = iti.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          MobileCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_wha = intlTelInput(txtAdWno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdWno.current.addEventListener("countrychange", () => {
        const selectedCountryData = iti_wha.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          WhatsAppNumberCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_whaParent = intlTelInput(txtAdFpo.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdFpo.current.addEventListener("countrychange", () => {
        const selectedCountryData = iti_whaParent.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          ParentMobileNoCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });
    }, []);

    useEffect(() => {
      fetchUserInfo(userId);
    }, [userId]);

    return (
      <div className="CommunicationForm">
        {/* contact details */}
        <fieldset className="mt-3">
          <legend className="w-auto">Contact Details</legend>
          <form className="row g-3">
            {/* Phone Number Field */}
            <div className="col-md-6">
              <label htmlFor="phone_no" className="form-label confirm_value">
                Phone Number
              </label>
              <input
                ref={txtAdPno}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                // type="tel"
                id="phone_no"
                name="phone_no"
                placeholder="Enter the phone number"
                // autoComplete="tel"
                required
                maxLength={10}
                // inputMode="tel"
                value={addressList.phone_no}
                onChange={handleInputChange}
                onBlur={handleBlur}
              />
              {listErrors?.phone_no && (
                <p className="error_message">{listErrors.phone_no}</p>
              )}
            </div>

            {/* WhatsApp Number Field */}
            <div className="col-md-6">
              <div className="d-flex justify-content-between">
                <label
                  htmlFor="whatsapp_no"
                  className="form-label confirm_value"
                >
                  WhatsApp Number
                </label>
                <div>
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    id="same_as_phone"
                    checked={isSameAsPhone}
                    onChange={() => {
                      setIsSameAsPhone((prev) => {
                        const newValue = !prev;
                        setAddressList((prevAddress) => ({
                          ...prevAddress,
                          contact_type: newValue ? "1" : "0",
                          whatsapp_no: newValue ? prevAddress.whatsapp_no : "",
                        }));
                        return newValue;
                      });
                      if (!isSameAsPhone) {
                        // when checked, copy phone_no to whatsapp_no
                        handleInputChange({
                          target: {
                            name: "whatsapp_no",
                            value: addressList.phone_no,
                          },
                        });
                      }
                    }}
                  />
                  <label
                    htmlFor="same_as_phone"
                    className="form-label confirm_label"
                  >
                    Same as Contact Number
                  </label>
                </div>
              </div>
              <input
                ref={txtAdWno}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="tel"
                id="whatsapp_no"
                name="whatsapp_no"
                placeholder="Enter the WhatsApp number"
                maxLength={10}
                inputMode="tel"
                value={addressList.whatsapp_no}
                onChange={handleInputChange}
                onBlur={handleBlur}
                disabled={isSameAsPhone}
                style={isSameAsPhone ? { cursor: "not-allowed" } : {}}
              />
              {addressList?.whatsapp_no?.length > 0 &&
                addressList?.whatsapp_no?.length < 10 && (
                  <p className="error_message">
                    Please enter a valid 10 digit number
                  </p>
                )}
            </div>

            {/* Father/Guardian Phone Number */}
            <div className="col-md-6">
              <label
                htmlFor="parent_mob_no"
                className="form-label confirm_value"
              >
                Father/Guardian Phone Number
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                ref={txtAdFpo}
                type="tel"
                id="parent_mob_no"
                name="parent_mob_no"
                placeholder="Enter the father/guardian phone number"
                maxLength={10}
                inputMode="tel"
                value={addressList.parent_mob_no}
                onChange={handleInputChange}
                onBlur={handleBlur}
              />
              {addressList?.parent_mob_no?.length > 0 &&
                addressList?.parent_mob_no?.length < 10 && (
                  <p className="error_message">
                    Please enter a valid 10 digit number
                  </p>
                )}
            </div>

            {/* Email Field */}
            <div className="col-md-6">
              <label htmlFor="email" className="form-label confirm_value">
                Email ID
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="email"
                id="email"
                name="email"
                placeholder="Enter the email"
                value={addressList.email}
                onChange={handleInputChange}
                style={{ cursor: "not-allowed" }}
                disabled
              />
            </div>
          </form>
        </fieldset>
        {/* present address */}
        <fieldset className="mt-3">
          <legend className="w-auto">Present Address</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label for="address1" class="form-label confirm_value ">
                House/Flat Number & Name
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="address1"
                name="address1"
                placeholder="Enter the house/flat number & name"
                value={addressList?.address?.[0]?.address1 || ""}
                onChange={(e) => handleAddressChange(e, 0)}
                //   onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label for="address2" class="form-label confirm_value ">
                Street Name
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="address2"
                name="address2"
                placeholder="Enter the street name"
                value={addressList?.address[0]?.address2}
                onChange={(e) => handleAddressChange(e, 0)}
                //   value={initialfields.age}
                //   onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label for="address3" class="form-label confirm_value ">
                Locality/Area
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="address3"
                name="address3"
                placeholder="Enter the locality/area"
                value={addressList?.address[0]?.address3}
                onChange={(e) => handleAddressChange(e, 0)}
              />
            </div>
            <div className="col-md-6">
              <label for="landmark" class="form-label confirm_value ">
                Landmark
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="landmark"
                name="landmark"
                placeholder="Enter the landmark"
                value={addressList?.address[0]?.landmark}
                onChange={(e) => handleAddressChange(e, 0)}
              />
            </div>
            <div className="col-md-6">
              <label for="post_name" class="form-label confirm_value ">
                Post
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="post_name"
                name="post_name"
                placeholder="Enter the post"
                value={addressList?.address[0]?.post_name}
                onChange={(e) => handleAddressChange(e, 0)}
              />
            </div>
            <div className="col-md-6">
              <label for="taluk" class="form-label confirm_value ">
                Taluk
              </label>
              <input
                class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                type="text"
                id="taluk"
                name="taluk"
                placeholder="Enter the taluk"
                value={addressList?.address[0]?.taluk}
                onChange={(e) => handleAddressChange(e, 0)}
              />
            </div>
            {/* Postal Code Input */}
            <div className="col-md-6">
              <label htmlFor="postal_code" className="form-label confirm_value">
                Pin/Postal Code
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="number"
                id="postal_code"
                name="postal_code"
                placeholder="Enter the pin/postal code"
                value={addressList?.address[0]?.postal_code || ""}
                onChange={(e) => handlePincodeChange(e, 0)} // API call on 6-digit entry
              />
              {addressList?.address[0]?.postal_code &&
                addressList.address[0].postal_code.toString().length < 6 &&
                addressList.address[0].postal_code.toString().charAt(0) !==
                  "0" && (
                  <p className="error_message">Please enter a valid pincode</p>
                )}
            </div>

            {/* City Field: Switches between Input & Dropdown */}
            <div className="col-md-6">
              <label htmlFor="city" className="form-label confirm_value">
                City/Town/Village
              </label>
              {addressList?.address[0]?.isDropdown ? (
                <Select
                  placeholder="Select City"
                  styles={customStyles}
                  options={addressList?.address[0]?.cityOptions || []}
                  value={
                    addressList?.address[0]?.city
                      ? {
                          value: addressList?.address[0]?.city,
                          label: addressList?.address[0]?.city,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleCityChange(selectedOption, 0)
                  }
                />
              ) : (
                <input
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  type="text"
                  id="city"
                  name="city"
                  placeholder="Enter the city/town/village"
                  value={addressList?.address[0]?.city}
                  readOnly
                />
              )}
            </div>

            {/* District Field (Auto-filled) */}
            <div className="col-md-6">
              <label
                htmlFor="district_name"
                className="form-label confirm_value"
              >
                District
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="district_name"
                name="district_name"
                placeholder="Enter the district"
                value={addressList?.address[0]?.district_name}
                readOnly
              />
            </div>

            {/* State Field (Auto-filled) */}
            <div className="col-md-6">
              <label htmlFor="state_name" className="form-label confirm_value">
                State/Union Territory
              </label>
              <input
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="state_name"
                name="state_name"
                placeholder="Enter the state/union territory"
                value={addressList?.address[0]?.state_name}
                readOnly
              />
            </div>
          </form>
        </fieldset>

        {/* permanent address */}
        <fieldset className="mt-3">
          <legend className="w-auto">Permanent Address</legend>
          <form className="row g-3">
            <div className="mb-3">
              <input
                className={`${styles.checkBox_input} me-2`}
                type="checkbox"
                id="present_address"
                checked={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                }
                onChange={handleSameAddressToggle}
              ></input>
              <label
                htmlFor="present_address"
                for="present_address"
                class="form-label confirm_label "
              >
                Same as Present Address
              </label>
            </div>
          </form>
          <form className="row g-3">
            <div className="col-md-6">
              <label for="address1" class="form-label confirm_value ">
                House/Flat Number & Name
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="address1"
                name="address1"
                placeholder="Enter the house/flat number & name"
                value={addressList?.address?.[1]?.address1 || ""}
                onChange={(e) => handleAddressChange(e, 1)}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
              />
            </div>
            <div className="col-md-6">
              <label for="address2" class="form-label confirm_value ">
                Street Name
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="address2"
                name="address2"
                placeholder="Enter the street name"
                value={addressList?.address[1]?.address2}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
            <div className="col-md-6">
              <label for="address3" class="form-label confirm_value ">
                Locality/Area
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="address3"
                name="address3"
                placeholder="Enter the locality/area"
                value={addressList?.address[1]?.address3}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
            <div className="col-md-6">
              <label for="landmark" class="form-label confirm_value ">
                Landmark
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="landmark"
                name="landmark"
                placeholder="Enter the landmark"
                value={addressList?.address[1]?.landmark}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
            <div className="col-md-6">
              <label for="post_name" class="form-label confirm_value ">
                Post
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="post_name"
                name="post_name"
                placeholder="Enter the post"
                value={addressList?.address[1]?.post_name}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
            <div className="col-md-6">
              <label for="taluk" class="form-label confirm_value ">
                Taluk
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="taluk"
                name="taluk"
                placeholder="Enter the taluk"
                value={addressList?.address[1]?.taluk}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
            <div className="col-md-6">
              <label for="postal_code" class="form-label confirm_value ">
                Pin/Postal Code
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="number"
                id="postal_code"
                name="postal_code"
                placeholder="Enter the pin/postal code"
                value={addressList?.address[1]?.postal_code || ""}
                disabled={
                  Number(addressList?.address?.[0]?.same_address) === 0 &&
                  Number(addressList?.address?.[1]?.same_address) === 0
                }
                // Disable when same
                // onChange={(e) => handleAddressChange(e, 1)}
                onChange={(e) => handlePincodeChange(e, 1)}
              />
              {addressList?.address[1]?.postal_code &&
                addressList.address[1].postal_code.toString().length < 6 &&
                addressList.address[1].postal_code.toString().charAt(0) !==
                  "0" && (
                  <p className="error_message">Please enter a valid pincode</p>
                )}
            </div>

            <div className="col-md-6">
              <label htmlFor="city" className="form-label confirm_value">
                City/Town/Village
              </label>
              {addressList?.address[1]?.isDropdown ? (
                <Select
                  style={{
                    cursor:
                      addressList?.address?.[0]?.same_address == 0 &&
                      addressList?.address?.[1]?.same_address == 0
                        ? "not-allowed"
                        : "auto",
                  }}
                  placeholder="Select City"
                  className="w-100"
                  options={addressList?.address[1]?.cityOptions || []}
                  isDisabled={
                    Number(addressList?.address?.[0]?.same_address) === 0 &&
                    Number(addressList?.address?.[1]?.same_address) === 0
                  }
                  value={
                    addressList?.address[1]?.city
                      ? {
                          value: addressList?.address[1]?.city,
                          label: addressList?.address[1]?.city,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleCityChange(selectedOption, 1)
                  }
                />
              ) : (
                <input
                  className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "bg-light text-muted"
                      : ""
                  }`}
                  style={{
                    cursor:
                      addressList?.address?.[0]?.same_address == 0 &&
                      addressList?.address?.[1]?.same_address == 0
                        ? "not-allowed"
                        : "auto",
                  }}
                  type="text"
                  id="city"
                  name="city"
                  placeholder="Enter the city/town/village"
                  value={addressList?.address[1]?.city}
                  disabled={
                    Number(addressList?.address?.[0]?.same_address) === 0 &&
                    Number(addressList?.address?.[1]?.same_address) === 0
                  }
                  readOnly
                />
              )}
            </div>
            <div className="col-md-6">
              <label for="district_name" class="form-label confirm_value ">
                District
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="district_name"
                name="district_name"
                placeholder="Enter the district"
                value={addressList?.address[1]?.district_name}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>

            <div className="col-md-6">
              <label for="state_name" class="form-label confirm_value ">
                State/Union Territory
              </label>
              <input
                className={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                    ? "bg-light text-muted"
                    : ""
                }`}
                style={{
                  cursor:
                    addressList?.address?.[0]?.same_address == 0 &&
                    addressList?.address?.[1]?.same_address == 0
                      ? "not-allowed"
                      : "auto",
                }}
                type="text"
                id="state_name"
                name="state_name"
                placeholder="Enter the state/union territory"
                value={addressList?.address[1]?.state_name}
                disabled={
                  addressList?.address?.[0]?.same_address == 0 &&
                  addressList?.address?.[1]?.same_address == 0
                } // Disable when same
                onChange={(e) => handleAddressChange(e, 1)}
              />
            </div>
          </form>
        </fieldset>
      </div>
    );
  }
);

const AcademicBackgroundForm = ({
  userId,
  eduList,
  setEduList,
  listErrors,
  setListErrors,
}) => {
  const [sslcIndex, setSslcIndex] = useState(0);
  const [hscIndex, setHscIndex] = useState(0);
  const [ugIndex, setUgIndex] = useState(0);
  const [pgIndex, setPgIndex] = useState(0);
  const [integratedPgIndex, setIntegratedPgIndex] = useState(0);
  const [diplomaIndex, setDiplomaIndex] = useState(0);
  const [professionalCoursesIndex, setProfessionalCoursesIndex] = useState(0);
  const [othersIndex, setOthersIndex] = useState(0);
  const [showSSLC, setShowSSLC] = useState(false);
  const [showHSC, setShowHSC] = useState(false);
  const [showUG, setShowUG] = useState(false);
  const [showPG, setShowPG] = useState(false);
  const [showIntegratedPG, setShowIntegratedPG] = useState(false);
  const [showDiploma, setShowDiploma] = useState(false);
  const [showProfessionalCourses, setShowProfessionalCourses] = useState(false);
  const [showOthers, setShowOthers] = useState(false);
  const [ugDegree, setUGDegree] = useState([]);
  const [selectedUGDegree, setSelectedUGDegree] = useState(null);
  const [majorOptions, setMajorOptions] = useState([]);
  const [selectedMajor, setSelectedMajor] = useState(null);
  const [pgDegree, setPGDegree] = useState([]);
  const [selectedPGDegree, setSelectedPGDegree] = useState(null);
  const [pgMajorOptions, setPGMajorOptions] = useState([]);
  const [selectedPGMajor, setSelectedPGMajor] = useState(null);
  const [integratedPgDegree, setIntegratedPgDegree] = useState([]); // Store IPG degree options
  const [selectedIntegratedPgDegree, setSelectedIntegratedPgDegree] =
    useState(null); // Store selected IPG degree
  const [integratedPgMajorOptions, setIntegratedPgMajorOptions] = useState([]); // Store IPG major options
  const [selectedIntegratedPgMajor, setSelectedIntegratedPgMajor] =
    useState(null);
  const [diplomaDegreeOptions, setDiplomaDegreeOptions] = useState([]); // From API
  const [diplomaMajorOptions, setDiplomaMajorOptions] = useState([]);
  const [selectedDiplomaDegree, setSelectedDiplomaDegree] = useState(null);
  const [selectedDiplomaMajor, setSelectedDiplomaMajor] = useState(null);
  // Professional Courses - Degree & Major
  const [pcDegreeOptions, setPcDegreeOptions] = useState([]); // List of degrees fetched from API
  const [selectedPcDegree, setSelectedPcDegree] = useState(null); // Currently selected degree
  const [pcMajorOptions, setPcMajorOptions] = useState([]); // List of majors for selected PC degree
  const [selectedPcMajor, setSelectedPcMajor] = useState(null); // Currently selected major
  const [otherDegreeOptions, setOtherDegreeOptions] = useState([]);
  const [selectedOtherDegree, setSelectedOtherDegree] = useState(null);
  const [otherMajorOptions, setOtherMajorOptions] = useState([]);
  const [selectedOtherMajor, setSelectedOtherMajor] = useState(null);
  const [showOtherDegreeInput, setShowOtherDegreeInput] = useState(false);
  const [showOtherMajorInput, setShowOtherMajorInput] = useState(false);
  const [ipgDegree, setIPGDegree] = useState([]);
  const [diplomaDegree, setDiplomaDegree] = useState([]);
  const [pcDegree, setPCDegree] = useState([]);
  const [option, setOptions] = useState([]);
  const [computerOptionsList, setComputerOptionsList] = useState([]);
  // const [listErrors, setListErrors] = useState([]);
  const [coaOption, setCoaOptions] = useState([]);
  const [stenoOption, setStenoOptions] = useState([
    { label: "Junior", value: "Junior" },
    { label: "Senior", value: "Senior" },
    { label: "High Speed", value: "High Speed" },
  ]);
  const [optionsLanguage, setOptionsLanguage] = useState([
    { label: "English", value: "English" },
    { label: "Tamil", value: "Tamil" },
  ]);
  const [optionsGrade, setOptionsGrade] = useState([]);
  const [degreeOptions, setDegreeOptions] = useState([]);

  useEffect(() => {
    AxiosInstance.get("api/codevalues?codetype=CLASS_THQ")
      .then((res) => {
        const formatted = res.data.map((item) => ({
          label: item.name,
          value: item.name,
        }));
        setOptionsGrade(formatted);
      })
      .catch((err) => console.error("Grade API error", err));
  }, []);
  useEffect(() => {
    AxiosInstance.get("api/codevalues?codetype=THQ_K")
      .then((res) => {
        const formatted = res.data.map((item) => ({
          label: item.name,
          value: item.name,
        }));
        setComputerOptionsList(formatted);
      })
      .catch((err) => console.error("Grade API error", err));
  }, []);
  useEffect(() => {
    AxiosInstance.get("api/codevalues?codetype=THQ_COA")
      .then((res) => {
        const formatted = res.data.map((item) => ({
          label: item.name,
          value: item.name,
        }));
        setCoaOptions(formatted);
      })
      .catch((err) => console.error("Grade API error", err));
  }, []);
  const fetchTechnicalCourseOptions = async () => {
    try {
      const res = await AxiosInstance.get("api/codevalues?codetype=THQ");
      const list = res.data || [];
      const formatted = list.map((item) => ({
        label: item.description || item.name,
        value: item.name,
      }));
      setOptions(formatted);
    } catch (err) {
      console.error("Error fetching Technical Course options:", err);
    }
  };
  useEffect(() => {
    fetchTechnicalCourseOptions();
  }, []);
  const options = [
    { label: "Knowledge in computer", value: "Knowledge in computer" },
    { label: "COA", value: "COA" },
    { label: "Steno", value: "Steno" },
    { label: "Typewriting", value: "Typewriting" },
    { label: "Others", value: "Others" },
    // Add more if needed
  ];

  //  Handle input change
  const handleChange = async (index, field, value) => {
    const updated = [...eduList.tech_qualification];
    updated[index][field] = value;

    if (field === "name") {
      updated[index]["kdg_in_com"] = ""; // Reset course when tech course changes

      setEduList({ ...eduList, tech_qualification: updated });
    }

    // Update form state
    setEduList({ ...eduList, tech_qualification: updated });
  };

  const handleFileUpload = (index, name, event) => {
    const file = event.target.files?.[0];
    const errorKey = `${name}_${index}`;

    if (!file) return;

    // Check file type
    if (!allowedFileTypes.includes(file.type)) {
      setListErrors((prev) => ({
        ...prev,
        [errorKey]: "PDF, PNG, JPG, and JPEG files only allowed",
      }));
      return;
    }

    // Check file size
    if (file.size >= 2 * 1024 * 1024) {
      setListErrors((prev) => ({
        ...prev,
        [errorKey]: "File size must be less than 2MB",
      }));
      return;
    }

    // Clear previous errors if validations pass
    setListErrors((prev) => ({
      ...prev,
      [errorKey]: "",
    }));

    // Prepare file and upload
    const formData = new FormData();
    formData.append("TQ_path", file);

    AxiosInstance.post("api/upload/", formData)
      .then((res) => {
        setEduList((prevState) => {
          const updatedDetails = prevState.tech_qualification.map((item, i) => {
            if (i === index) {
              return {
                ...item,
                [name]: res.data.path,
                file: res.data.path,
                original_file_path: res.data.originalname,
                // uploaded_file: file,
              };
            }
            return item;
          });

          return {
            ...prevState,
            tech_qualification: updatedDetails,
          };
        });
      })
      .catch((error) => {
        // Optional error handling
        // Swal.fire({
        //   title: "Warning",
        //   text: error.message || "Upload failed",
        //   icon: "warning",
        //   confirmButtonText: "Ok",
        // });
      });
  };

  // === Add / Remove ===
  const handleAdd = () => {
    const newItem = {
      id: 0,
      name: "",
      kdg_in_com: "",
      lang: "",
      Cnum: "",
      grade: "",
      year: "",
      file: "",
      original_file_path: "",
      type_of_degree: 0,
    };
    setEduList((prev) => ({
      ...prev,
      tech_qualification: [...prev.tech_qualification, newItem],
    }));
  };

  const handleRemove = (name) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (!userJSON) {
      console.log("User Id cannot be found in session storage");
      return;
    }

    const user = JSON.parse(userJSON);
    const userid = user?.user_id;
    if (!userid) return;

    AxiosInstance.post("api/course/admission/delete/qualifications", {
      user_id: userid,
      name: name, // Use the name passed to the function
      qualification_type: "THQ",
    })
      .then((res) => {
        if (res.status === 200) {
          // Filter out the qualification with the matching name
          const updatedQualifications = eduList.tech_qualification.filter(
            (e) => e.name !== name // This removes the qualification with the given name
          );

          // Update the state with the modified qualifications list
          setEduList((prev) => ({
            ...prev,
            tech_qualification: updatedQualifications,
          }));

          // Ensure the Add More button shows only when the last fieldset is visible
          if (updatedQualifications.length === 1) {
            // Only one fieldset left, so no remove button should be visible
            setEduList((prev) => ({
              ...prev,
              tech_qualification: updatedQualifications,
            }));
          }
        }
      })
      .catch((error) => {
        console.error("Error deleting technical qualification:", error);
      });
  };
  const fetchUserInfo = async (userId) => {
    try {
      const res = await AxiosInstance.post(
        `api/course/admission/info_view/${userId}/0`
      );
      const userinfo = res.data.data;
      const defaultEduDetails = userinfo.edu || [];

      let eduDetails = [];
      let techQualifications = [];

      defaultEduDetails.forEach((item, index) => {
        if (item.qualification_type === "EDQ") {
          eduDetails.push({
            filePath: item.certificate_path || "",
            name: item.name || "",
            certificate_no: item.certificate_no || "",
            year_of_passing: item.year_of_passing || "",
            marks_percentage: item.marks_percentage || "",
            edu_board: item.edu_board || "",
            edu_medium: item.edu_medium || "",
            institute: item.institute || "",
            degree_name: item.degree_name || "",
            major_subject: item.major_subject || "",
            level: item.level || "",
            grade: item.grade || "",
            certificate_path: item.certificate_path || "",
            original_file_path: item.original_file_path || "",
            type_of_degree: item.type_of_degree || 0,
          });
        } else if (item.qualification_type === "THQ") {
          if (defaultEduDetails.length === 1) {
            techQualifications.push({
              id: 0, // Assigns a sequential ID based on array index
              name: item.name || "",
              level: item.kdg_in_com || "",
              // filePath: item.certificate_path || "",
              // level: item.major_subject || "",
              lang: item.edu_medium || "",
              Cnum: item.certificate_no || "",
              kdg_in_com: item.level || "",
              grade: item.grade || "",
              year: item.year_of_passing || "",
              file: item.certificate_path || "",
              original_file_path: item.original_file_path || "",
              type_of_degree: item.type_of_degree || 0,
            });
          } else {
            // if (item.name) {
            techQualifications.push({
              // filePath: item.certificate_path || "",
              id: item.id, // Assigns a sequential ID based on array index (item.id)
              name: item.name || "",
              level: item.major_subject || "",
              lang: item.edu_medium || "",
              Cnum: item.certificate_no || "",
              kdg_in_com: item.level || "",
              grade: item.grade || "",
              year: item.year_of_passing || "",
              file: item.certificate_path || "",
              original_file_path: item.original_file_path || "",
              type_of_degree: item.type_of_degree || 0,
            });
            // }
          }
        }
      });

      // Check existence of courses
      const sslcExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "sslc"
      );
      const hscExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "hsc"
      );
      const ugExists = defaultEduDetails.some(
        (edu) => edu.name?.toUpperCase() === "UG"
      );
      const pgExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "pg"
      );
      const integratedPgExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "integrated pg"
      );
      const diplomaExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "diploma"
      );
      const professionalCoursesExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "professional courses"
      );
      const othersExists = defaultEduDetails.some(
        (edu) => edu.name?.toLowerCase() === "others"
      );

      // Set show states
      setShowSSLC(sslcExists);
      setShowHSC(hscExists);
      setShowUG(ugExists);
      setShowPG(pgExists);
      setShowIntegratedPG(integratedPgExists);
      setShowDiploma(diplomaExists);
      setShowProfessionalCourses(professionalCoursesExists);
      setShowOthers(othersExists);

      // Update state and set indexes for all courses
      setEduList({
        edu_details: eduDetails,
        tech_qualification: techQualifications,
      });

      setSslcIndex(
        eduDetails.findIndex((edu) => edu.name?.toLowerCase() === "sslc")
      );
      setHscIndex(
        eduDetails.findIndex((edu) => edu.name?.toLowerCase() === "hsc")
      );
      setUgIndex(
        eduDetails.findIndex((edu) => edu.name?.toUpperCase() === "UG")
      );
      setPgIndex(
        eduDetails.findIndex((edu) => edu.name?.toLowerCase() === "pg")
      );
      setIntegratedPgIndex(
        eduDetails.findIndex(
          (edu) => edu.name?.toLowerCase() === "integrated pg"
        )
      );
      setDiplomaIndex(
        eduDetails.findIndex((edu) => edu.name?.toLowerCase() === "diploma")
      );
      setProfessionalCoursesIndex(
        eduDetails.findIndex(
          (edu) => edu.name?.toLowerCase() === "professional courses"
        )
      );
      setOthersIndex(
        eduDetails.findIndex((edu) => edu.name?.toLowerCase() === "others")
      );
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  // const handleEduDetailChange = (index, field, value) => {
  //   setEduList((prevState) => {
  //     if (index === -1) return prevState; // Prevent updates if index is invalid

  //     const updatedEduDetails = [...prevState.edu_details]; // Copy array
  //     updatedEduDetails[index] = {
  //       ...updatedEduDetails[index], // Copy object
  //       [field]: value, // Update field
  //     };

  //     return { ...prevState, edu_details: updatedEduDetails }; // Update state
  //   });
  // };

  // const handleEduFileChange = (index, name, e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const updatedEduList = { ...eduList };
  //     updatedEduList.edu_details[index][name] = file;
  //     updatedEduList.edu_details[index]["original_file_path"] = file.name;

  //     // You can also reset the error here if needed:
  //     // listErrors[name] = "";

  //     setEduList(updatedEduList);
  //   }
  // };
  const handleEduDetailChange = (index, field, value) => {
    if (index === -1) return;
    if (field === "marks_percentage" && parseFloat(value) < 0) return;
    setEduList((prevState) => {
      const updatedEduDetails = [...prevState.edu_details];
      updatedEduDetails[index] = {
        ...updatedEduDetails[index],
        [field]: value,
      };
      return { ...prevState, edu_details: updatedEduDetails };
    });

    // Handle validation for marks_percentage
    if (field === "marks_percentage") {
      const numVal = parseFloat(value);
      let errorMsg = "";
      if (isNaN(numVal) || numVal < 45) {
        errorMsg = "Marks percentage should be above 45%";
      } else if (numVal > 100) {
        errorMsg = "Marks percentage should be above 45% and less than 100%";
      }

      setListErrors((prevErrors) => ({
        ...prevErrors,
        [`marks_percentage_${index}`]: errorMsg,
      }));
    }
  };
  const handleEduChange = (index, field, value) => {
    setEduList((prevState) => {
      const updatedEduDetails = [...prevState.edu_details];
      updatedEduDetails[index] = {
        ...updatedEduDetails[index], // Preserve other fields
        [field]: value, // Update the specific field
      };
      return { ...prevState, edu_details: updatedEduDetails };
    });
  };
  const allowedFileTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];

  const handleEdu = (index, name, event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!allowedFileTypes.includes(file.type)) {
      if (name === "SSLC_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`sslcFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "HSC_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`hscFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "UG_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`ugFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "PG_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`pgFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "IP_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`ipFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "D_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`dFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "PC_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`pcFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      } else if (name === "Ot_Path") {
        setListErrors((prev) => ({
          ...prev,
          // [`${name}_${index}`]: "PDF, PNG, JPG, and JPEG files only allowed",
          [`otFileError`]: "PDF, PNG, JPG, and JPEG files only allowed",
        }));
        return;
      }
    }

    if (file.size >= 2 * 1024 * 1024) {
      if (name === "SSLC_Path") {
        setListErrors((prev) => ({
          ...prev,
          sslcFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "HSC_Path") {
        setListErrors((prev) => ({
          ...prev,
          hscFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "UG_Path") {
        setListErrors((prev) => ({
          ...prev,
          ugFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "PG_Path") {
        setListErrors((prev) => ({
          ...prev,
          pgFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "IP_Path") {
        setListErrors((prev) => ({
          ...prev,
          ipFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "D_Path") {
        setListErrors((prev) => ({
          ...prev,
          dFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "PC_Path") {
        setListErrors((prev) => ({
          ...prev,
          pcFileError: "File size must be less than 2MB",
        }));
        return;
      } else if (name === "Ot_Path") {
        setListErrors((prev) => ({
          ...prev,
          otFileError: "File size must be less than 2MB",
        }));
        return;
      }
    } else {
      //  If size is valid — clear the error for that name
      const errorKey = {
        SSLC_Path: "sslcFileError",
        HSC_Path: "hscFileError",
        UG_Path: "ugFileError",
        PG_Path: "pgFileError",
        IP_Path: "ipFileError",
        D_Path: "dFileError",
        PC_Path: "pcFileError",
        Ot_Path: "otFileError",
      }[name];

      if (errorKey) {
        setListErrors((prev) => ({
          ...prev,
          [errorKey]: "", // clear error
        }));
      }
    }

    const formData = new FormData();
    formData.append(name, file);

    AxiosInstance.post("api/upload/", formData)
      .then((res) => {
        setEduList((prevState) => {
          const updatedDetails = prevState.edu_details.map((item, i) => {
            if (i === index) {
              return {
                ...item,
                [name]: res.data.path,
                filePath: res.data.path,
                original_file_path: res.data.originalname,
                uploaded_file: file,
              };
            }
            return item;
          });

          return {
            ...prevState,
            edu_details: updatedDetails,
          };
        });

        setListErrors((prev) => ({
          ...prev,
          [`${name}_${index}`]: "",
        }));
      })
      .catch((error) => {
        Swal.fire({
          title: "Warning",
          text: error.message || "Upload failed",
          icon: "warning",
          confirmButtonText: "Ok",
        });
      });
  };

  useEffect(() => {
    fetchUserInfo(userId);
  }, [userId]);

  // useEffect(() => {
  //   // Fetch UG Degrees
  //   AxiosInstance.get("api/all/getDegreeNames/UG").then((res) => {
  //     const ugDegreeList = res.data.data.map((item) => ({
  //       value: item.name,
  //       label: item.name,
  //     }));
  //     setUGDegree(ugDegreeList);

  //     // **Prefill Selected UG Degree (if exists in data)**
  //     if (eduList.edu_details?.[ugIndex]?.degree_name) {
  //       const prefilledDegree = ugDegreeList.find(
  //         (d) => d.value === eduList.edu_details[ugIndex].degree_name
  //       );
  //       if (prefilledDegree) {
  //         setSelectedUGDegree(prefilledDegree);

  //         // Fetch major options for prefilled degree
  //         fetchMajors(prefilledDegree.value);
  //       }
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const fetchDegrees = async (
      degreeType,
      setDegreeState,
      setSelectedState,
      index
    ) => {
      try {
        const res = await AxiosInstance.get(
          `api/all/getDegreeNames/${degreeType}`
        );
        const degreeList = res.data.data.map((item) => ({
          value: item.name,
          label: item.name,
        }));

        setDegreeState(degreeList);

        // Prefill Degree if available
        const prefilledDegree = eduList.edu_details?.[index]?.degree_name;
        if (prefilledDegree) {
          const matchedDegree = degreeList.find(
            (d) => d.value === prefilledDegree
          );
          if (matchedDegree) {
            setSelectedState(matchedDegree);
            fetchMajors(matchedDegree.value, degreeType);
          }
        }
      } catch (error) {
        console.error(`Error fetching ${degreeType} degrees:`, error);
      }
    };

    // Fetch UG, PG, and IPG Degrees
    fetchDegrees("UG", setUGDegree, setSelectedUGDegree, ugIndex);
    fetchDegrees("PG", setPGDegree, setSelectedPGDegree, pgIndex);
    fetchDegrees(
      "IPG",
      setIntegratedPgDegree,
      setSelectedIntegratedPgDegree,
      integratedPgIndex
    );
    fetchDegrees(
      "DIPLOMA",
      setDiplomaDegreeOptions,
      setSelectedDiplomaDegree,
      diplomaIndex
    );
    fetchDegrees(
      "PC",
      setPcDegreeOptions,
      setSelectedPcDegree,
      professionalCoursesIndex
    );
    fetchDegrees(
      "OTHERS",
      setOtherDegreeOptions,
      setSelectedOtherDegree,
      othersIndex
    );
  }, [eduList]); // Add eduList as a dependency

  const fetchMajors = (degreeName, type) => {
    AxiosInstance.post("api/all/getDegreeMajor/", {
      degree_name: degreeName,
      type,
    })
      .then((res) => {
        const majorList = res.data.data.map((item) => ({
          value: item.name,
          label: item.name,
        }));

        switch (type) {
          case "UG":
            setMajorOptions(majorList);
            prefillMajor(
              majorList,
              eduList.edu_details?.[ugIndex]?.major_subject,
              setSelectedMajor
            );
            break;
          case "PG":
            setPGMajorOptions(majorList);
            prefillMajor(
              majorList,
              eduList.edu_details?.[pgIndex]?.major_subject,
              setSelectedPGMajor
            );
            break;
          case "IPG":
            setIntegratedPgMajorOptions(majorList);
            prefillMajor(
              majorList,
              eduList.edu_details?.[integratedPgIndex]?.major_subject,
              setSelectedIntegratedPgMajor
            );
            break;
          case "DIPLOMA":
            setDiplomaMajorOptions(majorList);
            prefillMajor(
              majorList,
              eduList.edu_details?.[diplomaIndex]?.major_subject,
              setSelectedDiplomaMajor
            );
            break;
          case "PC":
            setPcMajorOptions(majorList);
            prefillMajor(
              majorList,
              eduList.edu_details?.[professionalCoursesIndex]?.major_subject,
              setSelectedPcMajor
            );
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.error("Error fetching major list:", err);
      });
  };

  // Prefill function
  const prefillMajor = (majorList, prefilledMajor, setSelectedMajorState) => {
    if (prefilledMajor) {
      const matchedMajor = majorList.find((m) => m.value === prefilledMajor);
      if (matchedMajor) {
        setSelectedMajorState(matchedMajor);
      }
    }
  };

  const handleUGDegreeChange = (selectedOption) => {
    setSelectedUGDegree(selectedOption);

    // Clear previous major
    setSelectedMajor(null);
    setMajorOptions([]);

    // Update eduList state
    handleEduChange(ugIndex, "degree_name", selectedOption.value);
    handleEduChange(ugIndex, "major_subject", ""); // Clear stored major

    // Fetch new major options based on the selected UG degree
    fetchMajors(selectedOption.value, "UG");
  };

  const handlePGDegreeChange = (selectedOption) => {
    setSelectedPGDegree(selectedOption);

    // Clear previous major
    setSelectedPGMajor(null);
    setPGMajorOptions([]);

    // Update eduList state
    handleEduChange(pgIndex, "degree_name", selectedOption.value);
    handleEduChange(pgIndex, "major_subject", ""); // Clear stored major

    // Fetch new major options based on the selected PG degree
    fetchMajors(selectedOption.value, "PG");
  };
  const handleIntegratedPgDegreeChange = (selectedOption) => {
    setSelectedIntegratedPgDegree(selectedOption);
    setSelectedIntegratedPgMajor(null);
    setIntegratedPgMajorOptions([]);
    handleEduChange(integratedPgIndex, "degree_name", selectedOption.value);
    handleEduChange(integratedPgIndex, "major_subject", "");
    fetchMajors(selectedOption.value, "IPG");
  };
  const handleDiplomaDegreeChange = (selectedOption) => {
    setSelectedDiplomaDegree(selectedOption);
    setSelectedDiplomaMajor(null);
    setDiplomaMajorOptions([]);
    handleEduChange(diplomaIndex, "degree_name", selectedOption.value);
    handleEduChange(diplomaIndex, "major_subject", "");
    fetchMajors(selectedOption.value, "DIPLOMA");
  };
  const handlePcDegreeChange = (selectedOption) => {
    setSelectedPcDegree(selectedOption);
    setSelectedPcMajor(null);
    setPcMajorOptions([]);

    handleEduChange(
      professionalCoursesIndex,
      "degree_name",
      selectedOption.value
    );
    handleEduChange(professionalCoursesIndex, "major_subject", "");

    fetchMajors(selectedOption.value, "PC");
  };
  const handleOtherDegreeChange = (selectedOption) => {
    if (selectedOption.value === "Others") {
      setShowOtherDegreeInput(true);
      setSelectedOtherDegree(null);
      setSelectedOtherMajor(null);
      setOtherMajorOptions([]);
      handleEduChange(othersIndex, "degree_name", "");
      handleEduChange(othersIndex, "major_subject", "");
    } else {
      setShowOtherDegreeInput(false);
      setSelectedOtherDegree(selectedOption);
      handleEduChange(othersIndex, "degree_name", selectedOption.value);
      fetchMajors(selectedOption.value, "OTHERS");
    }
  };
  const handleOtherMajorChange = (selectedOption) => {
    if (selectedOption.value === "Others") {
      setShowOtherMajorInput(true);
      setSelectedOtherMajor(null);
      handleEduChange(othersIndex, "major_subject", "");
    } else {
      setShowOtherMajorInput(false);
      setSelectedOtherMajor(selectedOption);
      handleEduChange(othersIndex, "major_subject", selectedOption.value);
    }
  };

  const handleCheckboxChange = (name, checked) => {
    switch (name) {
      // sslc
      case "sslc":
        setShowSSLC(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "sslc"
            );
            if (existsIndex === -1) {
              updated.push({
                name: "sslc",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setSslcIndex(updated.length - 1); // set index after adding
            } else {
              setSslcIndex(existsIndex); // reuse if already exists
            }
            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("SSLC");
          setSslcIndex(-1);
        }
        break;
      // hsc
      case "hsc":
        setShowHSC(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "hsc"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "hsc",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setHscIndex(updated.length - 1);
            } else {
              setHscIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("HSC");
          setHscIndex(-1);
        }
        break;
      // ug
      case "UG":
        setShowUG(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "UG"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "UG",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setUgIndex(updated.length - 1);
            } else {
              setUgIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("UG");
          setUgIndex(-1);
        }
        break;
      // pg
      case "PG":
        setShowPG(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "PG"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "PG",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setPgIndex(updated.length - 1);
            } else {
              setPgIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("PG");
          setPgIndex(-1);
        }
        break;
      //Integrated PG
      case "Integrated PG":
        setShowIntegratedPG(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "Integrated PG"
            );
            if (existsIndex === -1) {
              updated.push({
                name: "Integrated PG",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setIntegratedPgIndex(updated.length - 1); // set index after adding
            } else {
              setIntegratedPgIndex(existsIndex); // reuse if already exists
            }
            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("Integrated PG");
          setIntegratedPgIndex(-1);
        }
        break;
      //diploma
      case "Diploma":
        setShowDiploma(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "Diploma"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "Diploma",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setDiplomaIndex(updated.length - 1);
            } else {
              setDiplomaIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("Diploma");
          setDiplomaIndex(-1);
        }
        break;
      // professional Courses
      case "Professional Courses":
        setShowProfessionalCourses(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "Professional Courses"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "Professional Courses",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setProfessionalCoursesIndex(updated.length - 1);
            } else {
              setProfessionalCoursesIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("Professional Courses");
          setProfessionalCoursesIndex(-1);
        }
        break;
      // Others
      case "Others":
        setShowOthers(checked);
        if (checked) {
          setEduList((prev) => {
            const updated = [...prev.edu_details];
            const existsIndex = updated.findIndex(
              (edu) => edu.name?.toLowerCase() === "Others"
            );

            if (existsIndex === -1) {
              updated.push({
                name: "Others",
                certificate_no: "",
                year_of_passing: "",
                marks_percentage: "",
                edu_board: "",
                edu_medium: "",
                institute: "",
                degree_name: "",
                major_subject: "",
                level: "",
                grade: "",
                certificate_path: "",
                original_file_path: "",
                type_of_degree: 0,
              });
              setOthersIndex(updated.length - 1);
            } else {
              setOthersIndex(existsIndex);
            }

            return {
              ...prev,
              edu_details: updated,
            };
          });
        } else {
          deleteQualification("Others");
          setOthersIndex(-1);
        }
        break;

      default:
        break;
    }
  };

  const deleteQualification = async (qualification) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (!userJSON) {
      console.log("User Id cannot be found in session storage");
      return;
    }

    const user = JSON.parse(userJSON);
    const userId = user?.user_id;
    if (!userId) return;

    try {
      const res = await AxiosInstance.post(
        "api/course/admission/delete/qualifications",
        {
          name: qualification,
          qualification_type: "EDQ",
          user_id: userId,
        }
      );

      if (res.status === 200) {
        const updatedQualifications = eduList.edu_details.filter((e) => {
          if (qualification === "SSLC") {
            return e.name !== "sslc";
          } else if (qualification === "HSC") {
            return e.name !== "hsc";
          } else {
            return e.name !== qualification;
          }
        });

        setEduList((prev) => ({
          ...prev,
          edu_details: updatedQualifications,
        }));
      }
    } catch (error) {
      console.error(
        `Error deleting ${qualification}:`,
        error.response?.data || error
      );
    }
  };

  const setMaxMonthYearTec = (value) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;
    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    // if (selectedDate > currentDate) {
    //   alert("Year of passing should be in past");
    // } else {
    //   // Return the value because it's not in the future
    //   return value;
    // }
  };
  const TechhandleChange_date = (date, id, name) => {
    const dateEYD = moment(date).format("YYYY-MM");
    if (setMaxMonthYearTec(dateEYD)) {
      setEduList((prevState) => {
        const updatedTech = (prevState.tech_qualification || []).map((q) => {
          if (q.id === id) {
            return { ...q, [name]: dateEYD, error_year_of_passing: "" };
          }
          return q;
        });

        return {
          ...prevState,
          tech_qualification: updatedTech,
        };
      });
    }
  };
  const setMaxMonthYear = (value, names) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      setListErrors((prevErrors) => ({
        ...prevErrors,
        [names]: "Year of passing should be in past",
      }));
      return false;
    } else {
      return value; // Valid date
    }
  };

  // Called when user picks year/month
  const handleAcademicYearChange = (year, month, id, fieldName) => {
    if (!year || month === undefined || month === null) {
      console.warn("Invalid year or month:", year, month);
      return;
    }

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}`;

    if (setMaxMonthYear(formattedDate, fieldName)) {
      setEduList((prevState) => ({
        ...prevState,
        edu_details: prevState.edu_details.map((item) =>
          item.id === id ? { ...item, [fieldName]: formattedDate } : item
        ),
      }));

      setListErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    } else {
      setEduList((prevState) => ({
        ...prevState,
        edu_details: prevState.edu_details.map((item) =>
          item.id === id ? { ...item, [fieldName]: "" } : item
        ),
      }));
    }
  };
  const handleTechYearChange = (year, month, id, fieldName) => {
    if (!year || month === undefined || month === null) {
      console.warn("Invalid year or month:", year, month);
      return;
    }

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}`;

    if (setMaxMonthYear(formattedDate, id)) {
      setEduList((prevState) => ({
        ...prevState,
        tech_qualification: prevState.tech_qualification.map((item) =>
          item.id === id ? { ...item, [fieldName]: formattedDate } : item
        ),
      }));

      setListErrors((prevErrors) => ({
        ...prevErrors,
        [id]: "", // Clearing error for the item.id
      }));
    } else {
      setEduList((prevState) => ({
        ...prevState,
        tech_qualification: prevState.tech_qualification.map((item) =>
          item.id === id ? { ...item, [fieldName]: "" } : item
        ),
      }));
    }
  };
  const TechhandleChanges = (option, index) => {
    setEduList((prevState) => {
      const techList = prevState.tech_qualification || [];

      const isNameExists = techList.some(
        (item, i) =>
          i !== index &&
          item.name?.toLowerCase() === option.value?.toLowerCase()
      );

      const updatedList = techList.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            name: isNameExists ? "" : option.value,
            error_name: isNameExists ? "Name already exist" : "",
          };
        }
        return item;
      });

      return {
        ...prevState,
        tech_qualification: updatedList,
      };
    });
  };

  const txtAdSpass = useRef(null);
  const handleEYDate = (date, id, fieldName) => {
    const formattedDate = moment(date).format("YYYY-MM");
    if (setMaxMonthYear(formattedDate, id)) {
      setEduList((prevState) => ({
        ...prevState,
        edu_details: prevState.edu_details.map((item) =>
          item.name === fieldName ? { ...item, [id]: formattedDate } : item
        ),
      }));

      setListErrors((prevErrors) => ({
        ...prevErrors,
        [id]: "",
      }));
    } else {
      setEduList((prevState) => ({
        ...prevState,
        edu_details: prevState.edu_details.map((item) =>
          item.name === fieldName ? { ...item, [id]: "" } : item
        ),
      }));
    }
  };
  const handleTQDate = (date, index, fieldName) => {
    const formattedDate = moment(date).format("YYYY-MM");

    if (setMaxMonthYear(formattedDate, index)) {
      setEduList((prevState) => {
        const updatedList = [...prevState.tech_qualification];
        updatedList[index][fieldName] = formattedDate;
        return {
          ...prevState,
          tech_qualification: updatedList,
        };
      });

      setListErrors((prevErrors) => ({
        ...prevErrors,
        [`tech_qualification_${index}_${fieldName}`]: "", // Clear specific error if any
      }));
    } else {
      setEduList((prevState) => {
        const updatedList = [...prevState.tech_qualification];
        updatedList[index][fieldName] = "";
        return {
          ...prevState,
          tech_qualification: updatedList,
        };
      });
    }
  };

  return (
    <>
      <div className="AcademicBackgroundForm">
        <fieldset className="mt-3">
          <legend className="w-auto">Educational Qualification</legend>
          <form className="row g-3">
            <div className="col-12">
              <label for="qualification" class="form-label confirm_value ">
                Select All The Academic Certificates You Have
              </label>
              <div className="mb-3 d-flex align-items-center">
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="sslc"
                    id="sslc"
                    value="sslc"
                    checked={showSSLC}
                    // onChange={(e) => setShowSSLC(e.target.checked)}
                    onChange={(e) =>
                      handleCheckboxChange("sslc", e.target.checked)
                    }
                  ></input>
                  <label for="sslc" className={`${styles.qualification_label}`}>
                    SSLC
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="hsc"
                    id="hsc"
                    value="hsc"
                    checked={showHSC}
                    onChange={(e) =>
                      handleCheckboxChange("hsc", e.target.checked)
                    }
                    // onChange={(e) => setShowHSC(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="hsc"
                    className={`${styles.qualification_label}`}
                  >
                    HSC
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="ug"
                    id="ug"
                    value="ug"
                    checked={showUG}
                    onChange={(e) =>
                      handleCheckboxChange("UG", e.target.checked)
                    }
                    // onChange={(e) => setShowUG(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="ug"
                    className={`${styles.qualification_label}`}
                  >
                    UG
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="pg"
                    id="pg"
                    value="pg"
                    checked={showPG}
                    onChange={(e) =>
                      handleCheckboxChange("PG", e.target.checked)
                    }
                    // onChange={(e) => setShowPG(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="pg"
                    className={`${styles.qualification_label}`}
                  >
                    PG
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="Integrated PG"
                    id="Integrated PG"
                    value="Integrated PG"
                    checked={showIntegratedPG}
                    onChange={(e) =>
                      handleCheckboxChange("Integrated PG", e.target.checked)
                    }
                    // onChange={(e) => setShowIntegratedPG(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="Integrated_PG"
                    className={styles.qualification_label}
                  >
                    <span className="d-none d-lg-inline">Integrated PG</span>
                    <span className="d-inline d-lg-none">IPG</span>
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="diploma"
                    id="diploma"
                    value="diploma"
                    checked={showDiploma}
                    onChange={(e) =>
                      handleCheckboxChange("Diploma", e.target.checked)
                    }
                    // onChange={(e) => setShowDiploma(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="diploma"
                    className={`${styles.qualification_label}`}
                  >
                    Diploma
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="professionalCourses"
                    id="professionalCourses"
                    value="professionalCourses"
                    checked={showProfessionalCourses}
                    onChange={(e) =>
                      handleCheckboxChange(
                        "Professional Courses",
                        e.target.checked
                      )
                    }
                    // onChange={(e) =>
                    //   setShowProfessionalCourses(e.target.checked)
                    // }
                  ></input>
                  <label
                    htmlFor="professionalCourses"
                    className={styles.qualification_label}
                  >
                    <span className="d-none d-lg-inline">
                      Professional Courses
                    </span>
                    <span className="d-inline d-lg-none">PC</span>
                  </label>
                </div>
                <div className="me-2">
                  <input
                    className={`${styles.checkBox_input} me-2`}
                    type="checkbox"
                    name="others"
                    id="others"
                    value="others"
                    checked={showOthers}
                    onChange={(e) =>
                      handleCheckboxChange("Others", e.target.checked)
                    }
                    // onChange={(e) => setShowOthers(e.target.checked)}
                  ></input>
                  <label
                    htmlFor="others"
                    className={`${styles.qualification_label}`}
                  >
                    Others
                  </label>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
        {/* SSLC Fieldset */}
        {showSSLC && (
          <fieldset className="mt-3">
            <legend className="w-auto">SSLC</legend>
            <form className="row g-3">
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="SSLC_CNo"
                  name="SSLC_CNo"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    sslcIndex !== -1
                      ? eduList.edu_details?.[sslcIndex]?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (sslcIndex !== -1) {
                      handleEduDetailChange(
                        sslcIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  name="year_of_passing"
                  fieldInput={eduList.edu_details[sslcIndex]?.year_of_passing}
                  fieldsId={eduList.edu_details[sslcIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[sslcIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[sslcIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[sslcIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[sslcIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"sslc"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  min="0"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[sslcIndex]?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      sslcIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${sslcIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${sslcIndex}`]}
                  </span>
                )}
              </div>
              {/* Education Board */}
              <div className="col-md-6">
                <label
                  htmlFor="educationBoard"
                  className="form-label confirm_value"
                >
                  Education Board
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionSEducation}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[sslcIndex]?.edu_board
                    ) || eduList.edu_details?.[sslcIndex]?.edu_board
                      ? {
                          value: eduList.edu_details[sslcIndex].edu_board,
                          label: eduList.edu_details[sslcIndex].edu_board,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(sslcIndex, "edu_board", selected.value)
                  }
                />
              </div>

              {/* Medium of Instruction */}
              <div className="col-md-6">
                <label
                  htmlFor="mediumInstru"
                  className="form-label confirm_value"
                >
                  Medium of Instruction
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionsMedium}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[sslcIndex]?.edu_medium
                    ) || eduList.edu_details?.[sslcIndex]?.edu_medium
                      ? {
                          value: eduList.edu_details[sslcIndex].edu_medium,
                          label: eduList.edu_details[sslcIndex].edu_medium,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(sslcIndex, "edu_medium", selected.value)
                  }
                />
              </div>

              {/* School Name */}
              <div className="col-md-6">
                <label
                  htmlFor="school_name"
                  className="form-label confirm_value"
                >
                  School Name
                </label>
                <input
                  type="text"
                  id="school_name"
                  name="school_name"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[sslcIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      sslcIndex,
                      "institute",
                      e.target.value
                    )
                  }
                />
              </div>

              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload SSLC Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[sslcIndex]?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[sslcIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="SSLC_Path"
                        type="file"
                        name="SSLC_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) => handleEdu(sslcIndex, "SSLC_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[sslcIndex]?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[sslcIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`sslcFileError`] && (
                      <span className="error_message">
                        {listErrors[`sslcFileError`]}
                      </span>
                    )}
                    {/* {listErrors?.SSLC_Path && (
                      <span className="error_message">
                        {listErrors.SSLC_Path}
                      </span>
                    )} */}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* HSC Fieldset */}
        {showHSC && (
          <fieldset className="mt-3">
            <legend className="w-auto">HSC</legend>
            <form className="row g-3">
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    hscIndex !== -1
                      ? eduList.edu_details?.[hscIndex]?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (hscIndex !== -1) {
                      handleEduDetailChange(
                        hscIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  minDate={
                    eduList.edu_details[sslcIndex]?.year_of_passing !== "" &&
                    eduList.edu_details[sslcIndex]?.year_of_passing !== null
                      ? eduList.edu_details[sslcIndex]?.year_of_passing
                      : ""
                  }
                  name="year_of_passing"
                  fieldInput={eduList.edu_details[hscIndex]?.year_of_passing}
                  fieldsId={eduList.edu_details[hscIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[hscIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[hscIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[hscIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[hscIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"hsc"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>

              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  min="0"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[hscIndex]?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      hscIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${hscIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${hscIndex}`]}
                  </span>
                )}
              </div>

              {/* Education Board */}
              <div className="col-md-6">
                <label
                  htmlFor="educationBoard"
                  className="form-label confirm_value"
                >
                  Education Board
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionSEducation}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value === eduList.edu_details?.[hscIndex]?.edu_board
                    ) || eduList.edu_details?.[hscIndex]?.edu_board
                      ? {
                          value: eduList.edu_details[hscIndex].edu_board,
                          label: eduList.edu_details[hscIndex].edu_board,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(hscIndex, "edu_board", selected.value)
                  }
                />
              </div>

              {/* Medium of Instruction */}
              <div className="col-md-6">
                <label
                  htmlFor="mediumInstru"
                  className="form-label confirm_value"
                >
                  Medium of Instruction
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionsMedium}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[hscIndex]?.edu_medium
                    ) || eduList.edu_details?.[hscIndex]?.edu_medium
                      ? {
                          value: eduList.edu_details[hscIndex].edu_medium,
                          label: eduList.edu_details[hscIndex].edu_medium,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(hscIndex, "edu_medium", selected.value)
                  }
                />
              </div>

              {/* School Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  School Name
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[hscIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(hscIndex, "institute", e.target.value)
                  }
                />
              </div>

              {/* Upload HSC Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="HSC_Path"
                    className="form-label confirm_value"
                  >
                    Upload HSC Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[hscIndex]?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[hscIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row">
                    <div>
                      <input
                        className="InputsSelectFile m-0"
                        id="HSC_Path"
                        type="file"
                        name="HSC_Path"
                        onChange={(e) => handleEdu(hscIndex, "HSC_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[hscIndex]?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[hscIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`hscFileError`] && (
                      <span className="error_message">
                        {listErrors[`hscFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* UG fieldset */}
        {showUG && (
          <fieldset className="mt-3">
            <legend className="w-auto">UG</legend>
            <form className="row g-3">
              {/* UG Degree */}
              <div className="col-md-6">
                <label htmlFor="ugDegree" className="form-label confirm_value">
                  Degree
                </label>
                <Select
                  id="ugDegree"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={ugDegree} // From useEffect
                  styles={customStyles}
                  value={selectedUGDegree}
                  onChange={handleUGDegreeChange}
                />
              </div>

              {/* UG Major */}
              <div className="col-md-6">
                <label htmlFor="ugMajor" className="form-label confirm_value">
                  Major
                </label>
                <Select
                  id="ugMajor"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={majorOptions}
                  styles={customStyles}
                  value={selectedMajor} // Prefilled or selected major
                  onChange={(selected) => {
                    setSelectedMajor(selected);
                    handleEduChange(ugIndex, "major_subject", selected.value);
                  }}
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  minDate={
                    eduList.edu_details[hscIndex]?.year_of_passing !== "" &&
                    eduList.edu_details[hscIndex]?.year_of_passing !== null
                      ? eduList.edu_details[hscIndex]?.year_of_passing
                      : ""
                  }
                  name="year_of_passing"
                  fieldInput={eduList.edu_details[ugIndex]?.year_of_passing}
                  fieldsId={eduList.edu_details[ugIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[ugIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[ugIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[ugIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[ugIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"UG"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    ugIndex !== -1
                      ? eduList.edu_details?.[ugIndex]?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (ugIndex !== -1) {
                      handleEduDetailChange(
                        ugIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={eduList.edu_details?.[ugIndex]?.marks_percentage || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      ugIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${ugIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${ugIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label
                  htmlFor="educationBoard"
                  className="form-label confirm_value"
                >
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value === eduList.edu_details?.[ugIndex]?.grade
                    ) || eduList.edu_details?.[ugIndex]?.grade
                      ? {
                          value: eduList.edu_details[ugIndex].grade,
                          label: eduList.edu_details[ugIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(ugIndex, "grade", selected.value)
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[ugIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(ugIndex, "institute", e.target.value)
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[ugIndex]?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[ugIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="UG_Path"
                        type="file"
                        name="UG_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) => handleEdu(ugIndex, "UG_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[ugIndex]?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[ugIndex]?.original_file_path ||
                            ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`ugFileError`] && (
                      <span className="error_message">
                        {listErrors[`ugFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* pg */}
        {showPG && (
          <fieldset className="mt-3">
            <legend className="w-auto">PG</legend>
            <form className="row g-3">
              {/* PG Degree */}
              <div className="col-md-6">
                <label className="form-label confirm_value">Degree</label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={pgDegree} //  Uses PG degree options
                  styles={customStyles}
                  value={selectedPGDegree} //  Binds selected PG degree
                  onChange={handlePGDegreeChange} //  Handles PG degree change
                />
              </div>

              {/* PG Major */}
              <div className="col-md-6">
                <label className="form-label confirm_value">Major</label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={pgMajorOptions} //  Uses PG major options
                  styles={customStyles}
                  value={selectedPGMajor} //  Binds selected PG major
                  onChange={(selected) => {
                    setSelectedPGMajor(selected);
                    handleEduChange(pgIndex, "major_subject", selected.value);
                  }}
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  minDate={
                    eduList.edu_details[ugIndex]?.year_of_passing !== "" &&
                    eduList.edu_details[ugIndex]?.year_of_passing !== null
                      ? eduList.edu_details[ugIndex]?.year_of_passing
                      : ""
                  }
                  name="year_of_passing"
                  fieldInput={eduList.edu_details[pgIndex]?.year_of_passing}
                  fieldsId={eduList.edu_details[pgIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[pgIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[pgIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[pgIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[pgIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"PG"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    pgIndex !== -1
                      ? eduList.edu_details?.[pgIndex]?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (pgIndex !== -1) {
                      handleEduDetailChange(
                        pgIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={eduList.edu_details?.[pgIndex]?.marks_percentage || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      pgIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${pgIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${pgIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label htmlFor="grade" className="form-label confirm_value">
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value === eduList.edu_details?.[pgIndex]?.grade
                    ) || eduList.edu_details?.[pgIndex]?.grade
                      ? {
                          value: eduList.edu_details[pgIndex].grade,
                          label: eduList.edu_details[pgIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(pgIndex, "grade", selected.value)
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[pgIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(pgIndex, "institute", e.target.value)
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[pgIndex]?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[pgIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="PG_Path"
                        type="file"
                        name="PG_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) => handleEdu(pgIndex, "PG_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[pgIndex]?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[pgIndex]?.original_file_path ||
                            ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`pgFileError`] && (
                      <span className="error_message">
                        {listErrors[`pgFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* Integrated PG */}
        {showIntegratedPG && (
          <fieldset className="mt-3">
            <legend className="w-auto">Integrated PG</legend>
            <form className="row g-3">
              {/* Integrated PG Degree */}
              <div className="col-md-6">
                <label
                  htmlFor="integratedPgDegree"
                  className="form-label confirm_value"
                >
                  Degree
                </label>
                <Select
                  id="integratedPgDegree"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={integratedPgDegree} // Fetched from API
                  styles={customStyles}
                  value={selectedIntegratedPgDegree}
                  onChange={handleIntegratedPgDegreeChange}
                />
              </div>

              {/* Integrated PG Major */}
              <div className="col-md-6">
                <label
                  htmlFor="integratedPgMajor"
                  className="form-label confirm_value"
                >
                  Major
                </label>
                <Select
                  id="integratedPgMajor"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={integratedPgMajorOptions}
                  styles={customStyles}
                  value={
                    integratedPgMajorOptions.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[integratedPgIndex]?.major_subject
                    ) || null
                  }
                  onChange={(selected) =>
                    handleEduChange(
                      integratedPgIndex,
                      "major_subject",
                      selected.value
                    )
                  }
                />
              </div>
              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  minDate={
                    eduList.edu_details[hscIndex]?.year_of_passing !== "" &&
                    eduList.edu_details[hscIndex]?.year_of_passing !== null
                      ? eduList.edu_details[hscIndex]?.year_of_passing
                      : ""
                  }
                  name="year_of_passing"
                  fieldInput={
                    eduList.edu_details[integratedPgIndex]?.year_of_passing
                  }
                  fieldsId={eduList.edu_details[integratedPgIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[integratedPgIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[integratedPgIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[integratedPgIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[integratedPgIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"Integrated PG"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    integratedPgIndex !== -1
                      ? eduList.edu_details?.[integratedPgIndex]
                          ?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (integratedPgIndex !== -1) {
                      handleEduDetailChange(
                        integratedPgIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[integratedPgIndex]
                      ?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      integratedPgIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${integratedPgIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${integratedPgIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label htmlFor="grade" className="form-label confirm_value">
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[integratedPgIndex]?.grade
                    ) || eduList.edu_details?.[integratedPgIndex]?.grade
                      ? {
                          value: eduList.edu_details[integratedPgIndex].grade,
                          label: eduList.edu_details[integratedPgIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(integratedPgIndex, "grade", selected.value)
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={
                    eduList.edu_details?.[integratedPgIndex]?.institute || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      integratedPgIndex,
                      "institute",
                      e.target.value
                    )
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[integratedPgIndex]
                      ?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[integratedPgIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="IP_Path"
                        type="file"
                        name="IP_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) =>
                          handleEdu(integratedPgIndex, "IP_Path", e)
                        }
                      />
                    </div>

                    {eduList.edu_details?.[integratedPgIndex]
                      ?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[integratedPgIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`ipFileError`] && (
                      <span className="error_message">
                        {listErrors[`ipFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* Diploma */}
        {showDiploma && (
          <fieldset className="mt-3">
            <legend className="w-auto">Diploma</legend>
            <form className="row g-3">
              {/* Diploma Degree */}
              <div className="col-md-6">
                <label
                  htmlFor="diplomaDegree"
                  className="form-label confirm_value"
                >
                  Degree
                </label>
                <Select
                  id="diplomaDegree"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={diplomaDegreeOptions} // Fetched from API
                  styles={customStyles}
                  value={selectedDiplomaDegree}
                  onChange={handleDiplomaDegreeChange}
                />
              </div>

              {/* Diploma Major */}
              <div className="col-md-6">
                <label
                  htmlFor="diplomaMajor"
                  className="form-label confirm_value"
                >
                  Major
                </label>
                <Select
                  id="diplomaMajor"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={diplomaMajorOptions}
                  styles={customStyles}
                  value={
                    diplomaMajorOptions.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[diplomaIndex]?.major_subject
                    ) || null
                  }
                  onChange={(selected) =>
                    handleEduChange(
                      diplomaIndex,
                      "major_subject",
                      selected.value
                    )
                  }
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  minDate={
                    eduList.edu_details[sslcIndex]?.year_of_passing !== "" &&
                    eduList.edu_details[sslcIndex]?.year_of_passing !== null
                      ? eduList.edu_details[sslcIndex]?.year_of_passing
                      : ""
                  }
                  name="year_of_passing"
                  fieldInput={
                    eduList.edu_details[diplomaIndex]?.year_of_passing
                  }
                  fieldsId={eduList.edu_details[diplomaIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[diplomaIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[diplomaIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[diplomaIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[diplomaIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"Diploma"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    diplomaIndex !== -1
                      ? eduList.edu_details?.[diplomaIndex]?.certificate_no ||
                        ""
                      : ""
                  }
                  onChange={(e) => {
                    if (diplomaIndex !== -1) {
                      handleEduDetailChange(
                        diplomaIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[diplomaIndex]?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      diplomaIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${diplomaIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${diplomaIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label htmlFor="grade" className="form-label confirm_value">
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value === eduList.edu_details?.[diplomaIndex]?.grade
                    ) || eduList.edu_details?.[diplomaIndex]?.grade
                      ? {
                          value: eduList.edu_details[diplomaIndex].grade,
                          label: eduList.edu_details[diplomaIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(diplomaIndex, "grade", selected.value)
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[diplomaIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      diplomaIndex,
                      "institute",
                      e.target.value
                    )
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[diplomaIndex]
                      ?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[diplomaIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="D_Path"
                        type="file"
                        name="D_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) => handleEdu(diplomaIndex, "D_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[diplomaIndex]
                      ?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[diplomaIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`dFileError`] && (
                      <span className="error_message">
                        {listErrors[`dFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* Professional Courses */}
        {showProfessionalCourses && (
          <fieldset className="mt-3">
            <legend className="w-auto">Professional Courses</legend>
            <form className="row g-3">
              {/* Professional Course Degree */}
              <div className="col-md-6">
                <label htmlFor="pcDegree" className="form-label confirm_value">
                  Degree
                </label>
                <Select
                  id="pcDegree"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={pcDegreeOptions}
                  styles={customStyles}
                  value={selectedPcDegree}
                  onChange={handlePcDegreeChange}
                />
              </div>

              {/* Professional Course Major */}
              <div className="col-md-6">
                <label htmlFor="pcMajor" className="form-label confirm_value">
                  Major
                </label>
                <Select
                  id="pcMajor"
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={pcMajorOptions}
                  styles={customStyles}
                  value={
                    pcMajorOptions.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[professionalCoursesIndex]
                          ?.major_subject
                    ) || null
                  }
                  onChange={(selected) =>
                    handleEduChange(
                      professionalCoursesIndex,
                      "major_subject",
                      selected.value
                    )
                  }
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  name="year_of_passing"
                  fieldInput={
                    eduList.edu_details[professionalCoursesIndex]
                      ?.year_of_passing
                  }
                  fieldsId={eduList.edu_details[professionalCoursesIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[professionalCoursesIndex]
                          ?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[professionalCoursesIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[professionalCoursesIndex]
                          ?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[professionalCoursesIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"Professional Courses"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_number"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    professionalCoursesIndex !== -1
                      ? eduList.edu_details?.[professionalCoursesIndex]
                          ?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (professionalCoursesIndex !== -1) {
                      handleEduDetailChange(
                        professionalCoursesIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[professionalCoursesIndex]
                      ?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      professionalCoursesIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${diplomaIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${diplomaIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label htmlFor="grade" className="form-label confirm_value">
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value ===
                        eduList.edu_details?.[professionalCoursesIndex]?.grade
                    ) || eduList.edu_details?.[professionalCoursesIndex]?.grade
                      ? {
                          value:
                            eduList.edu_details[professionalCoursesIndex].grade,
                          label:
                            eduList.edu_details[professionalCoursesIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(
                      professionalCoursesIndex,
                      "grade",
                      selected.value
                    )
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={
                    eduList.edu_details?.[professionalCoursesIndex]
                      ?.institute || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      professionalCoursesIndex,
                      "institute",
                      e.target.value
                    )
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[professionalCoursesIndex]
                      ?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[professionalCoursesIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="PC_Path"
                        type="file"
                        name="PC_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) =>
                          handleEdu(professionalCoursesIndex, "PC_Path", e)
                        }
                      />
                    </div>

                    {eduList.edu_details?.[professionalCoursesIndex]
                      ?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[professionalCoursesIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`pcFileError`] && (
                      <span className="error_message">
                        {listErrors[`pcFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
        {/* Others */}
        {showOthers && (
          <fieldset className="mt-3">
            <legend className="w-auto">Others</legend>
            <form className="row g-3">
              {/* Degree */}
              <div className="col-md-6">
                <label className="form-label confirm_value">Degree</label>
                <input
                  type="text"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter your degree"
                  value={eduList.edu_details?.[othersIndex]?.degree_name || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      othersIndex,
                      "degree_name",
                      e.target.value
                    )
                  }
                />
              </div>

              {/* Major */}
              <div className="col-md-6">
                <label className="form-label confirm_value">Major</label>
                <input
                  type="text"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter your major"
                  value={
                    eduList.edu_details?.[othersIndex]?.major_subject || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      othersIndex,
                      "major_subject",
                      e.target.value
                    )
                  }
                />
              </div>

              {/* Year of Passing */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Year of Passing
                </label>
                <MonthDatePicker
                  name="year_of_passing"
                  fieldInput={eduList.edu_details[othersIndex]?.year_of_passing}
                  fieldsId={eduList.edu_details[othersIndex]?.id}
                  handleYearChange={(year) =>
                    handleAcademicYearChange(
                      year,
                      moment(
                        eduList.edu_details[othersIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).month() + 1,
                      eduList.edu_details[othersIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  handleMonthChange={(month) =>
                    handleAcademicYearChange(
                      moment(
                        eduList.edu_details[othersIndex]?.year_of_passing,
                        "YYYY-MM"
                      ).year(),
                      moment(month, "MMMM").month() + 1,
                      eduList.edu_details[othersIndex]?.id,
                      "year_of_passing"
                    )
                  }
                  disabledProperty={false}
                  dname={"Others"}
                  txtAdSpass={txtAdSpass}
                  handleChange={handleEYDate}
                />
              </div>
              {/* Certificate Number */}
              <div className="col-md-6">
                <label
                  htmlFor="certificate_no"
                  className="form-label confirm_value"
                >
                  Certificate Number
                </label>
                <input
                  type="text"
                  id="certificate_no"
                  name="certificate_no"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the certificate number"
                  value={
                    othersIndex !== -1
                      ? eduList.edu_details?.[othersIndex]?.certificate_no || ""
                      : ""
                  }
                  onChange={(e) => {
                    if (othersIndex !== -1) {
                      handleEduDetailChange(
                        othersIndex,
                        "certificate_no",
                        e.target.value
                      );
                    }
                  }}
                />
              </div>
              {/* Marks Percentage */}
              <div className="col-md-6">
                <label
                  htmlFor="marks_percentage"
                  className="form-label confirm_value"
                >
                  Marks Percentage
                </label>
                <input
                  type="number"
                  min="0"
                  id="marks_percentage"
                  name="marks_percentage"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the marks percentage"
                  value={
                    eduList.edu_details?.[othersIndex]?.marks_percentage || ""
                  }
                  onChange={(e) =>
                    handleEduDetailChange(
                      othersIndex,
                      "marks_percentage",
                      e.target.value
                    )
                  }
                />
                {listErrors[`marks_percentage_${othersIndex}`] && (
                  <span className="error_message">
                    {listErrors[`marks_percentage_${othersIndex}`]}
                  </span>
                )}
              </div>
              {/* Class */}
              <div className="col-md-6">
                <label htmlFor="grade" className="form-label confirm_value">
                  Class
                </label>
                <Select
                  className="shadow-none input-font-size"
                  isSearchable
                  placeholder="Please select"
                  options={optionClass}
                  styles={customStyles}
                  value={
                    optionSEducation.find(
                      (opt) =>
                        opt.value === eduList.edu_details?.[othersIndex]?.grade
                    ) || eduList.edu_details?.[othersIndex]?.grade
                      ? {
                          value: eduList.edu_details[othersIndex].grade,
                          label: eduList.edu_details[othersIndex].grade,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleEduChange(othersIndex, "grade", selected.value)
                  }
                />
              </div>
              {/* university Name */}
              <div className="col-md-6">
                <label htmlFor="institute" className="form-label confirm_value">
                  Name of the college / university
                </label>
                <input
                  type="text"
                  id="institute"
                  name="institute"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the school name"
                  value={eduList.edu_details?.[othersIndex]?.institute || ""}
                  onChange={(e) =>
                    handleEduDetailChange(
                      othersIndex,
                      "institute",
                      e.target.value
                    )
                  }
                />
              </div>
              {/* Upload Certificate */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="certificate_path"
                    className="form-label confirm_value"
                  >
                    Upload Certificate (In pdf/Image format)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {eduList.edu_details?.[othersIndex]?.original_file_path && (
                      <a
                        href={`${ImageUrlPrefix}/${eduList.edu_details[othersIndex].certificate_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        type="application/pdf"
                        download
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <div className="row d-flex align-items-center">
                    <div>
                      <input
                        id="Ot_Path"
                        type="file"
                        name="Ot_Path"
                        className="InputsSelectFile m-0"
                        onChange={(e) => handleEdu(othersIndex, "Ot_Path", e)}
                      />
                    </div>

                    {eduList.edu_details?.[othersIndex]?.original_file_path && (
                      <div className="mt-1">
                        <span className={`${styles.uploadFile} m-0`}>
                          {eduList.edu_details?.[othersIndex]
                            ?.original_file_path || ""}
                        </span>
                      </div>
                    )}
                    {listErrors[`otFileError`] && (
                      <span className="error_message">
                        {listErrors[`otFileError`]}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        )}
      </div>

      {eduList.tech_qualification.map((tech, index) => (
        <fieldset className="mt-3" key={tech.id}>
          <legend className="w-auto">
            Technical Qualification {index + 1}
          </legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label className="form-label confirm_value">
                Technical Course
              </label>
              <Select
                className="shadow-none input-font-size"
                isSearchable
                placeholder="Please select"
                styles={customStyles}
                options={options}
                value={
                  options.find(
                    (opt) =>
                      opt?.value?.toLowerCase() === tech?.name?.toLowerCase()
                  ) || null
                }
                onChange={(selected) => TechhandleChanges(selected, index)}
              />
              {tech?.error_name && (
                <small className="error_message">{tech.error_name}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label confirm_value">
                {tech.name === "Steno"
                  ? "Stenographer Level"
                  : tech.name === "COA"
                  ? "Computer Office Automation"
                  : tech.name === "Knowledge in computer"
                  ? "Course In Computer"
                  : tech.name === "Others"
                  ? "Course In Computer"
                  : "Typewriting Level"}
              </label>

              {tech?.name === "COA" && (
                <Select
                  isSearchable
                  className="shadow-none input-font-size"
                  placeholder="Please select"
                  styles={customStyles}
                  options={coaOption || []}
                  value={
                    (coaOption || []).find(
                      (opt) =>
                        opt?.value?.toLowerCase() ===
                        tech?.kdg_in_com?.toLowerCase()
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange(index, "kdg_in_com", selected?.value || "")
                  }
                />
              )}

              {tech?.name === "Knowledge in computer" && (
                <Select
                  isSearchable
                  className="shadow-none input-font-size"
                  placeholder="Please select"
                  styles={customStyles}
                  options={computerOptionsList || []}
                  value={
                    (computerOptionsList || []).find(
                      (opt) =>
                        opt?.value?.toLowerCase() ===
                        tech?.kdg_in_com?.toLowerCase()
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange(index, "kdg_in_com", selected?.value || "")
                  }
                />
              )}

              {(tech?.name === "Steno" ||
                tech?.name === "Typewriting" ||
                !tech?.name) && (
                <Select
                  isSearchable
                  className="shadow-none input-font-size"
                  placeholder="Please select"
                  styles={customStyles}
                  options={stenoOption || []} // <-- Junior/Senior/High Speed
                  value={
                    (stenoOption || []).find(
                      (opt) =>
                        opt?.value?.toLowerCase() ===
                        tech?.kdg_in_com?.toLowerCase()
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange(index, "kdg_in_com", selected?.value || "")
                  }
                />
              )}

              {tech?.name === "Others" && (
                <input
                  type="text"
                  className="form-control input-font-size shadow-none"
                  placeholder="Enter course"
                  value={tech?.kdg_in_com || ""}
                  onChange={(e) =>
                    handleChange(index, "kdg_in_com", e.target.value)
                  }
                />
              )}
            </div>

            <div className="col-md-6">
              <label
                htmlFor={`optionsLanguage_${index}`}
                className="form-label confirm_value"
              >
                Language
              </label>
              <Select
                className="shadow-none input-font-size"
                isSearchable
                placeholder="Please select"
                options={optionsLanguage}
                styles={customStyles}
                value={
                  optionsLanguage.find(
                    (option) => option.value === tech.lang
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleChange(index, "lang", selectedOption.value)
                }
              />
            </div>
            <div className="col-md-6">
              <label
                htmlFor={`certificate_number_${index}`}
                className="form-label confirm_value"
              >
                Certificate Number
              </label>
              <input
                type="text"
                id={`certificate_number_${index}`}
                name="certificate_number"
                placeholder="Enter the certificate number"
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                value={tech.Cnum}
                onChange={(e) => handleChange(index, "Cnum", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label
                htmlFor={`optionsGrade_${index}`}
                className="form-label confirm_value"
              >
                Grade
              </label>
              <Select
                className="shadow-none input-font-size"
                isSearchable
                placeholder="Please select"
                options={optionsGrade}
                styles={customStyles}
                value={
                  optionsGrade.find((option) => option.value === tech.grade) ||
                  null
                }
                onChange={(selectedOption) =>
                  handleChange(index, "grade", selectedOption.value)
                }
              />
            </div>
            <div className="col-md-6">
              <label
                htmlFor={`year${index}`}
                className="form-label confirm_value"
              >
                Year of Passing
              </label>
              <MonthDatePicker
                name={index}
                fieldInput={eduList.tech_qualification[index]?.year}
                fieldsId={eduList.tech_qualification[index]?.id}
                handleYearChange={(year) =>
                  handleTechYearChange(
                    year,
                    moment(
                      eduList.tech_qualification[index]?.year ||
                        moment().format("YYYY-MM"),
                      "YYYY-MM"
                    ).month() + 1,
                    eduList.tech_qualification[index]?.id,
                    "year"
                  )
                }
                handleMonthChange={(month) =>
                  handleTechYearChange(
                    moment(
                      eduList.tech_qualification[index]?.year ||
                        moment().format("YYYY-MM"),
                      "YYYY-MM"
                    ).year(),
                    moment(month, "MMMM").month() + 1,
                    eduList.tech_qualification[index]?.id,
                    "year"
                  )
                }
                dname={"year"}
                disabledProperty={false}
                txtAdSpass={txtAdSpass}
                handleChange={handleTQDate}
              />
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="forms">
                <label
                  htmlFor="certificate_path"
                  className="form-label confirm_value"
                >
                  Upload Certificate (In pdf/Image format)
                  <span className="form-label confirm_label"> (optional)</span>
                  {eduList.tech_qualification?.[index]?.original_file_path && (
                    <a
                      href={`${ImageUrlPrefix}/${eduList.tech_qualification[index].file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      type="application/pdf"
                      download
                    >
                      <span className="material-icons download_icon align-middle text-danger">
                        file_download
                      </span>
                    </a>
                  )}
                </label>

                <div className="row d-flex align-items-center">
                  <div>
                    <input
                      id={`uploadCertificate_${index}`}
                      type="file"
                      name="certificate_path"
                      className="InputsSelectFile m-0"
                      onChange={(e) => handleFileUpload(index, "TQ_path", e)}
                    />
                  </div>
                  {eduList.tech_qualification?.[index]?.original_file_path && (
                    <div className="mt-1">
                      <span className={`${styles.uploadFile} m-0`}>
                        {eduList.tech_qualification?.[index]
                          ?.original_file_path || ""}
                      </span>
                    </div>
                  )}
                  {/* {listErrors?.TQ_path && (
                    <span className="error_message">{listErrors.TQ_path}</span>
                  )} */}
                  {listErrors[`TQ_path_${index}`] && (
                    <span className="error_message">
                      {listErrors[`TQ_path_${index}`]}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-12 d-flex justify-content-end g-3">
              {/* Show remove button only if there's more than one technical qualification */}
              {eduList.tech_qualification.length > 1 && (
                <a
                  className={`${styles.AddMore}`}
                  onClick={() => handleRemove(tech?.name)}
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className={`material-icons align-middle me-1 ${styles.addIcon}`}
                  >
                    remove_circle
                  </span>
                  Delete Technical Qualification
                </a>
              )}

              {/* Show Add More button only for the last fieldset */}
              {index === eduList.tech_qualification.length - 1 && (
                <a
                  className={`${styles.AddMore} ms-3`}
                  onClick={handleAdd}
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className={`material-icons align-middle me-1 ${styles.addIcon}`}
                  >
                    add_circle
                  </span>
                  Add More Technical Qualification
                </a>
              )}
            </div>
          </form>
        </fieldset>
      ))}
    </>
  );
};

//  Each step includes header, subheader, and form component

export default function HorizontalLinearStepper() {
  const [activeStep, setActiveStep] = useState(1);
  const [skipped, setSkipped] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [listErrors, setListErrors] = useState({});
  const navigate = useNavigate();
  const personalFormRef = useRef(); // ref to child component
  const communicationRef = useRef();
  // const firstNameRef = useRef(null);
  const [list, setList] = useState({
    FirstName: "",
    LastName: "",
    Fathername: "",
    MotherName: "",
    Profilephoto: null,
    DOB: "",
    age: 0,
    gender: "Male",
    MaritalStatus: "Single/Unmarried",
    aadharNo: "",
    aadharCardphoto: null,
    original_aadhar_path: null,
    original_profile_path: null,
    original_caste_path: null,
    community_name: "",
  });

  const [addressList, setAddressList] = useState({
    phone_no: "",
    email: "",
    // whatsapp_no: null,
    // parent_mob_no: "",
    country_code: "+91",
    contact_type: "0",
    address: [
      {
        address1: "",
        address2: "",
        address3: "",
        landmark: "",
        post_name: "",
        taluk: "",
        postal_code: "0",
        city: "",
        cityOptions: [],
        district_name: "",
        state_name: "",
        same_address: "1",
        address_type: "1",
        isDropdown: false,
      },
      {
        address1: "",
        address2: "",
        address3: "",
        landmark: "",
        post_name: "",
        taluk: "",
        postal_code: "0",
        city: "",
        cityOptions: [],
        district_name: "",
        state_name: "",
        same_address: "1",
        address_type: "2",
        isDropdown: false,
      },
    ],
  });

  const [eduList, setEduList] = useState({
    edu_details: [],
    tech_qualification: [],
  });

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  const steps = [
    {
      header: "Personal Profile",
      subheader: "Define Your Identity",
      content: (
        <PersonalProfileForm
          ref={personalFormRef}
          list={list}
          setList={setList}
          listErrors={listErrors}
          setListErrors={setListErrors}
        />
      ),
    },
    {
      header: "Communication",
      subheader: "Stay Connected Always",
      content: (
        <CommunicationForm
          ref={communicationRef}
          userId={userid}
          addressList={addressList}
          setAddressList={setAddressList}
          listErrors={listErrors}
          setListErrors={setListErrors}
        />
      ),
    },
    {
      header: "Academic Background",
      subheader: "Your Learning Journey",
      content: (
        <AcademicBackgroundForm
          userId={userid}
          eduList={eduList}
          setEduList={setEduList}
          listErrors={listErrors}
          setListErrors={setListErrors}
        />
      ),
    },
  ];
  const isStepSkipped = (step) => skipped.has(step);
  const validatePersonalForm = () => {
    let errors = {};
    const onlyLetters = /^[A-Za-z\s]+$/;
    let firstErrorField = null;
    const refs = personalFormRef.current?.refs;

    if (!list.FirstName.trim()) {
      errors.FirstName = "Please enter the first name";
      firstErrorField = refs.firstNameRef;
    } else if (!onlyLetters.test(list.FirstName)) {
      errors.FirstName = "Only letters are allowed";
      firstErrorField = refs.firstNameRef;
    }

    if (!list.LastName.trim()) {
      errors.LastName = "Please enter the last name";
      if (!firstErrorField) firstErrorField = refs.lastNameRef;
    } else if (!onlyLetters.test(list.LastName)) {
      errors.LastName = "Only letters are allowed";
      if (!firstErrorField) firstErrorField = refs.lastNameRef;
    }

    if (!list.Fathername.trim()) {
      errors.Fathername = "Please enter the father's name";
      if (!firstErrorField) firstErrorField = refs.fatherNameRef;
    } else if (!onlyLetters.test(list.Fathername)) {
      errors.Fathername = "Only letters are allowed";
      if (!firstErrorField) firstErrorField = refs.fatherNameRef;
    }

    if (!list.MotherName.trim()) {
      errors.MotherName = "Please enter the mother's name";
      if (!firstErrorField) firstErrorField = refs.motherNameRef;
    } else if (!onlyLetters.test(list.MotherName)) {
      errors.MotherName = "Only letters are allowed";
      if (!firstErrorField) firstErrorField = refs.motherNameRef;
    }

    if (!list.DOB) {
      errors.DOB = "Please select your date of birth";
      if (!firstErrorField) firstErrorField = refs.dobRef;
    }

    if (!list.gender) {
      errors.gender = "Please select gender";
      if (!firstErrorField) firstErrorField = refs.genderRef;
    }

    if (!list.MaritalStatus) {
      errors.MaritalStatus = "Please select marital status";
      if (!firstErrorField) firstErrorField = refs.maritalStatusRef;
    }

    if (!list.Profilephoto) {
      errors.Profilephoto = "Please upload a passport size photograph";
      if (!firstErrorField) firstErrorField = refs.profilePhotoRef;
    } else if (list.profileFile && list.profileFile.size >= 40 * 1024) {
      errors.Profilephoto = "Profile photo must be less than 40KB";
      if (!firstErrorField) firstErrorField = refs.profilePhotoRef;
    }

    if (!list.aadharNo) {
      errors.aadharNo = "Please enter Aadhar number";
      if (!firstErrorField) firstErrorField = refs.aadharNoRef;
    } else if (!/^\d{12}$/.test(list.aadharNo)) {
      errors.aadharNo = "Please Enter valid 12 digit number";
      if (!firstErrorField) firstErrorField = refs.aadharNoRef;
    }

    if (!list.aadharCardphoto) {
      errors.aadharCardphoto = "Please upload aadhar card";
      if (!firstErrorField) firstErrorField = refs.aadharCardRef;
    } else if (
      list.aadharCardFile &&
      list.aadharCardFile.size > 2 * 1024 * 1024
    ) {
      errors.aadharCardphoto = "File must be less than 2MB";
      if (!firstErrorField) firstErrorField = refs.aadharCardRef;
    }

    if (!list.community_name) {
      errors.community_name = "Please select category";
      if (!firstErrorField) firstErrorField = refs.communityRef;
    }
    if (list.castFileObj && list.castFileObj.size > 2 * 1024 * 1024) {
      errors.CastFile = "File must be less than 2MB";
      if (!firstErrorField) firstErrorField = refs.castRef;
    }

    setListErrors(errors);

    if (firstErrorField?.current) {
      setTimeout(() => firstErrorField.current.focus(), 100); // ensure DOM is ready
    }

    return Object.keys(errors).length === 0;
  };

  const validateEducationForm = () => {
    let isValid = true;
    const errors = {};

    // Validate marks_percentage
    eduList.edu_details.forEach((item, index) => {
      const val = item.marks_percentage;
      const fieldKey = `marks_percentage_${index}`;

      if (val !== "" && val !== undefined && val !== null) {
        const numVal = parseFloat(val);

        if (isNaN(numVal)) {
          errors[fieldKey] = "Please enter a valid number";
          isValid = false;
        } else if (numVal < 45) {
          errors[fieldKey] = "Marks percentage should be above 45%";
          isValid = false;
        } else if (numVal > 100) {
          errors[fieldKey] =
            "Marks percentage should be less than or equal to 100%";
          isValid = false;
        }
      }
    });

    // Validate uploaded files in edu_details (e.g. SSLC, HSC, UG, etc.)

    // Set all collected errors
    setListErrors((prev) => ({ ...prev, ...errors }));

    return isValid;
  };

  const handleNext = async (e) => {
    e.preventDefault();
    // setListErrors({});
    setLoading(true);
    let isValid = true;

    // Step-wise validation
    if (activeStep === 0) {
      isValid = validatePersonalForm();
    }
    // else if (activeStep === 1) {
    //   const isCommunicationValid = communicationRef.current?.validateFields?.(); // validate mobile numbers
    //   const isAddressValid = validateAddressForm(); // validate other address fields

    //   // if (!isCommunicationValid || !isAddressValid) {
    //   //   console.warn("Step 1 validation failed.");
    //   //   setLoading(false);
    //   //   return; // stop if any validation fails
    //   // }
    // }
    else if (activeStep === 2) {
      // Validate the form and block if invalid
      const isValid = validateEducationForm();
      if (!isValid) {
        setLoading(false);
        return;
      }
    }
    if (!isValid) {
      console.warn("Validation failed. Please check your inputs.");
      setLoading(false);
      return;
    }
    let payload = {};
    // STEP 0: PERSONAL DETAILS
    if (activeStep === 0) {
      payload = {
        user_id: userid,
        step: 1,
        id: "",
        type: 0,
        first_name: list.FirstName,
        last_name: list.LastName,
        father_name: list.Fathername,
        mother_name: list.MotherName,
        dob: moment(list.DOB).format("YYYY-MM-DD"),
        age: list.age || 0,
        gender: list.gender,
        marital_status: list.MaritalStatus,
        profile_path: list.Profilephoto,
        aadhar_no: list.aadharNo,
        original_aadhar_path: list.original_aadhar_path || null,
        original_profile_path: list.original_profile_path || null,
        original_caste_path: list.original_caste_path || null,
        aadhar_path: list.aadharCardphoto,
        community_name: list.community_name || "General",
        community_path: list.CastFile || null,
        scp: [],
      };
    }

    // STEP 1: ADDRESS DETAILS
    else if (activeStep === 1) {
      // const cleanedAddresses =
      //   addressList?.address?.map(
      //     ({ cityOptions, isDropdown, ...rest }) => rest
      //   ) || [];
      const cleanedAddresses =
        addressList?.address?.map(({ cityOptions, isDropdown, ...rest }) => ({
          ...rest,
          postal_code:
            typeof rest.postal_code === "string" &&
            rest.postal_code.trim() === ""
              ? "0"
              : rest.postal_code,
        })) || [];

      payload = {
        user_id: userid,
        step: 2,
        contact_type: addressList?.contact_type || "0",
        ...addressList,
        address: cleanedAddresses,
        phone_no: addressList?.phone_no || null,
        whatsapp_no: addressList?.whatsapp_no || null,
        parent_mob_no: addressList?.parent_mob_no || null,
        email: addressList?.email,
      };
    }

    // STEP 2: EDUCATIONAL & TECHNICAL DETAILS
    else if (activeStep === 2) {
      const updatedEduDetails = (eduList.edu_details || [])
        .map((entry) => {
          const commonFields = {
            certificate_no: entry.certificate_no,
            certificate_path: entry.certificate_path,
            edu_board: entry.edu_board,
            edu_medium: entry.edu_medium,
            institute: entry.institute,
            marks_percentage: entry.marks_percentage || null,
            year_of_passing: entry.year_of_passing,
            grade: entry.grade,
            degree_name: entry.degree_name,
            major_subject: entry.major_subject,
            UGMajor_Other: entry.UGMajor_Other,
            original_file_path: entry.original_file_path,
            filePath: entry.filePath,
          };
          switch (entry.name) {
            case "sslc":
              return {
                // original_file_path
                SSLC_CNo: commonFields.certificate_no,
                SSLC_Path: commonFields.filePath,
                SSLC_Eboard: commonFields.edu_board,
                SSLC_MI: commonFields.edu_medium,
                SSLC_Scl: commonFields.institute,
                SSLC_Marks: commonFields.marks_percentage || null,
                SSLC_Year: commonFields.year_of_passing,
                original_file_path: commonFields.original_file_path,
                name: "sslc",
              };
            case "hsc":
              return {
                HSC_CNo: commonFields.certificate_no,
                HSC_Path: commonFields.filePath,
                HSC_Ebaord: commonFields.edu_board,
                HSC_MI: commonFields.edu_medium,
                HSC_Scl: commonFields.institute,
                HSC_Marks: commonFields.marks_percentage || null,
                HSC_Year: commonFields.year_of_passing,
                original_file_path: commonFields.original_file_path,
                name: "hsc",
              };
            case "UG":
              return {
                UGCertificateNumber: commonFields.certificate_no,
                UGClassName: commonFields.grade,
                UGDegree: commonFields.degree_name,
                UGMajor: commonFields.major_subject,
                UGMajor_Other: commonFields.UGMajor_Other,
                UGMarksPercentage: commonFields.marks_percentage || null,
                UGNameInstitute: commonFields.institute,
                UGYearpassing: commonFields.year_of_passing,
                UG_Path: commonFields.filePath,
                name: "UG",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 0,
              };
            case "PG":
              return {
                PGCertificateNumber: commonFields.certificate_no,
                PGClassName: commonFields.grade,
                PGDegree: commonFields.degree_name,
                PGMajor: commonFields.major_subject,
                PGMajor_Other: commonFields.UGMajor_Other,
                PGMarksPercentage: commonFields.marks_percentage || null,
                PGNameInstitute: commonFields.institute,
                PGYearpassing: commonFields.year_of_passing,
                PG_Path: commonFields.filePath,
                name: "PG",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 0,
              };
            case "Integrated PG":
              return {
                IPCertificateNumber: commonFields.certificate_no,
                IPClassName: commonFields.grade,
                IPDegree: commonFields.degree_name,
                IPMajor: commonFields.major_subject,
                IPMajor_Other: commonFields.UGMajor_Other,
                IPMarksPercentage: commonFields.marks_percentage || null,
                IPNameInstitute: commonFields.institute,
                IPYearpassing: commonFields.year_of_passing,
                IP_Path: commonFields.filePath,
                name: "Integrated PG",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 0,
              };
            case "Diploma":
              return {
                DCertificateNumber: commonFields.certificate_no,
                DClassName: commonFields.grade,
                DDegree: commonFields.degree_name,
                DMajor: commonFields.major_subject,
                DMajor_Other: commonFields.UGMajor_Other,
                DMarksPercentage: commonFields.marks_percentage || null,
                DNameInstitute: commonFields.institute,
                DYearpassing: commonFields.year_of_passing,
                D_Path: commonFields.filePath,
                name: "Diploma",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 0,
              };
            case "Professional Courses":
              return {
                PCCertificateNumber: commonFields.certificate_no,
                PCClassName: commonFields.grade,
                PCDegree: commonFields.degree_name,
                PCMajor: commonFields.major_subject,
                PCMajor_Other: commonFields.UGMajor_Other,
                PCMarksPercentage: commonFields.marks_percentage || null,
                PCNameInstitute: commonFields.institute,
                PCYearpassing: commonFields.year_of_passing,
                PC_Path: commonFields.filePath,
                name: "Professional Courses",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 0,
              };
            case "Others":
              return {
                OtCertificateNumber: commonFields.certificate_no,
                OtClassName: commonFields.grade,
                OtDegree: commonFields.degree_name,
                OtMajor: commonFields.major_subject,
                OtMajor_Other: commonFields.UGMajor_Other,
                OtMarksPercentage: commonFields.marks_percentage || null,
                OtNameInstitute: commonFields.institute,
                OtYearpassing: commonFields.year_of_passing,
                Ot_Path: commonFields.filePath,
                name: "Others",
                qualification_type: "Others",
                original_file_path: commonFields.original_file_path,
                type_of_degree: 1,
              };
            default:
              return null;
          }
        })
        .filter(Boolean);

      const updatedTechQualification = (eduList.tech_qualification || []).map(
        (entry) => ({
          ...entry,
          level: entry.kdg_in_com,
          kdg_in_com: "",
        })
      );

      payload = {
        user_id: userid,
        step: 3,
        contact_type: "0",
        edu_details: updatedEduDetails,
        tech_qualification: updatedTechQualification,
      };
    }

    //  Final API Call
    try {
      const response = await AxiosInstance.post(
        "api/course/admission/register",
        payload
      );

      if (response.data?.status === true) {
        setListErrors({});
        if (activeStep === 2) {
          navigate("/StudentProfile");
        } else {
          const newSkipped = isStepSkipped(activeStep)
            ? new Set([...skipped].filter((step) => step !== activeStep))
            : skipped;

          setActiveStep((prev) => prev + 1);
          setSkipped(newSkipped);
        }
      } else {
        console.error("Validation Errors:", response.data.listErrors);
        setListErrors(response.data.listErrors || {});
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("Failed to save data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const navigateScreen = () => {
    navigate(`/StudentProfile`);
  };
  // const handleReset = () => {
  //   setActiveStep(0);
  //   setSkipped(new Set());
  // };

  return (
    <div className="EditProfile BathHeader global_container">
      <div className="row mb-4 ">
        <div className="col-md-6 col-6">
          <h2 className="TitleHeader">Edit Profile</h2>
        </div>
        <div className="col-md-6 col-6 ListBtn mt-4 mt-lg-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                onClick={navigateScreen}
                to="javascript:void(0)"
                className="secondaryButton px-0"
                variant="secondary"
              >
                Back to Profile
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="stepperIcon">
        <Stepper activeStep={activeStep}>
          {steps.map((section, index) => {
            const stepProps = {};
            const labelProps = {};

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }

            return (
              <Step key={index} {...stepProps}>
                <StepLabel {...labelProps}>
                  <div className="text-center mt-2">
                    <p
                      className="form-label confirm_value d-lg-block d-none"
                      style={{
                        color:
                          activeStep === index || activeStep > index
                            ? "#c0272d"
                            : "#041134",
                        fontWeight:
                          activeStep === index || activeStep > index
                            ? "600"
                            : "normal",
                      }}
                    >
                      {section.header}
                    </p>
                    <p
                      className="d-lg-block d-none"
                      style={{
                        color:
                          activeStep === index || activeStep > index
                            ? "#041134"
                            : "gray",
                        fontSize: "12px",
                        fontWeight:
                          activeStep === index || activeStep > index
                            ? "600"
                            : "normal",
                      }}
                    >
                      {section.subheader}
                    </p>
                  </div>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </div>

      {/* link top buttons */}
      <div
        className={`d-flex my-4 ${
          activeStep === 0
            ? "justify-content-end"
            : "justify-content-between gap-2"
        }`}
      >
        {/* Left Side Back Button */}
        {activeStep !== 0 && (
          <button
            type="button"
            className={`${styles.SaveButton}`}
            onClick={handleBack}
          >
            <span className={styles.arrowIconL}>&larr;</span>
            <span className={styles.buttonTextL}>
              {activeStep === 2
                ? "Go to Communication"
                : activeStep === 1
                ? "Go to Personal Details"
                : ""}
            </span>
          </button>
        )}

        {/* Right Side Next/Save Button */}
        <button
          type="button"
          className={`${styles.SaveButton}`}
          onClick={handleNext}
        >
          <span className={styles.buttonText}>
            {activeStep === steps.length - 1
              ? "Save Profile"
              : activeStep === 1
              ? "Save & Continue to Academic Background"
              : "Save & Continue to Communication"}
          </span>
          <span className={styles.arrowIcon}>&rarr;</span>
        </button>
      </div>
      {/* steps content */}
      <div className="">{steps[activeStep].content}</div>
      {/* link bottom buttons */}
      <div
        className={`d-flex my-4 ${
          activeStep === 0
            ? "justify-content-end"
            : "justify-content-between gap-2"
        }`}
      >
        {/* Left Side Back Button */}
        {activeStep !== 0 && (
          <button
            type="button"
            className={`${styles.SaveButton}`}
            onClick={handleBack}
          >
            <span className={styles.arrowIconL}>&larr;</span>
            <span className={styles.buttonTextL}>
              {activeStep === 2
                ? "Go to Communication"
                : activeStep === 1
                ? "Go to Personal Details"
                : ""}
            </span>
          </button>
        )}

        {/* Right Side Next/Save Button */}
        <button
          type="button"
          className={`${styles.SaveButton}`}
          onClick={handleNext}
        >
          <span className={styles.buttonText}>
            {activeStep === steps.length - 1
              ? "Save Profile"
              : activeStep === 1
              ? "Save & Continue to Academic Background"
              : "Save & Continue to Communication"}
          </span>
          <span className={styles.arrowIcon}>&rarr;</span>
        </button>
      </div>
    </div>
  );
}
